import {AfterViewChecked, ChangeDetectorRef, Component, OnDestroy, OnInit, signal, ViewChild} from '@angular/core';
import {ClaimService} from '../../../services/claim.service';
import {AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {combineLatest, forkJoin, iif, Observable, of, Subject, throwError} from 'rxjs';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {ReturnMessageDTO} from '../../../models/ReturnMessageDTO';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {MatStep, MatStepper} from '@angular/material/stepper';
import {catchError, debounceTime, finalize, switchMap, take, takeUntil} from 'rxjs/operators';
import {PagedRequestDTO} from '../../../../common/models/PagedRequestDTO';
import {PagedFilterDTO, PagedFilterDTONew} from '../../../../common/models/PagedFilterDTO';
import {InsuredPersonService} from '../../../../ent/services/insured-person.service';
import {InsuredPersonDTO} from '../../../../ent/models/InsuredPersonDTO';
import {PolicyDTO} from '../../../../ent/models/PolicyDTO';
import {ProductDTO} from '../../../../ent/models/ProductDTO';
import {InsuredPersonWithDatesDTO} from '../../../../ent/models/InsuredPersonWithDatesDTO';
import {ProviderDTO} from '../../../../ent/models/ProviderDTO';
import {ProviderService} from '../../../../ent/services/provider.service';
import {DatePipe} from '@angular/common';
import {CaseService} from '../../../services/case.service';
import {CreateNameValueDTO, NameValueDTO} from '../../../../common/models/NameValueDTO';
import {DiagnosisDTO} from '../../../../ent/models/DiagnosisDTO';
import {DiagnosisService} from '../../../../ent/services/diagnosis.service';
import {CodingSchemaDTO} from '../../../../ent/models/CodingSchemaDTO';
import {CodingSchemaService} from '../../../../ent/services/coding-schema.service';
import {Request} from '../../../models/claim/Request';
import {ClaimTotalsDTO} from '../../../models/claim/ClaimTotalsDTO';
import {ClaimDTO} from '../../../models/claim/ClaimDTO';
import {MembershipDTO} from '../../../models/claim/MembershipDTO';
import {LineDTO} from '../../../models/claim/LineDTO';
import {ClaimDiagnosisDTO} from '../../../models/claim/ClaimDiagnosisDTO';
import {ClaimResultsDialogComponent} from '../../dialogs/claim-results-dialog/claim-results-dialog.component';
import {MatButton} from '@angular/material/button';
import {Common, createFieldMap, formatNumber} from '../../../../common/util/Util';
import {DateUtil} from 'src/app/modules/common/util/DateUtil';
import {LookupService} from 'src/app/modules/common/services/lookup.service';
import {ClaimReviewService} from '../../../services/claim-review.service';
import {ClaimReviewDTO} from '../../../models/claim-review/ClaimReviewDTO';
import {GenericListDialogComponent} from '../../../../common/dialogs/generic-list-dialog/generic-list-dialog.component';
import {RuleMessageDTO} from '../../../models/RuleMessageDTO';
import {AddJustificationDialogComponent} from '../../dialogs/add-justification-dialog/add-justification-dialog.component';
import {AssessmentNarrativeDTO} from '../../../models/AssessmentNarrativeDTO';
import {AssessmentNarrativeService} from '../../../services/assessment-narrative.service';
import {RuleMessageService} from '../../../services/rule-message.service';
import {WorkflowResultDTO} from '../../../models/WorkflowResultDTO';
import {CaseType} from '../../../types';
import {ChangedDataErrorDialogComponent} from '../../dialogs/changed-data-error-dialog/changed-data-error-dialog.component';
import {ContactArrayDTO} from '../../../../ent/models/ContactsArrayDTO';
import {AddressesArrayDTO} from '../../../../ent/models/AddressesArrayDTO';
import {SharedService} from '../../../../common/services/shared-service';
import {CaseHospitalProviderLinkDTO} from '../../../models/case-hospital/CaseHospitalProviderLinkDTO';
import {CaseHospitalDiagnosisLinkDTO} from '../../../models/case-hospital/CaseHospitalDiagnosisLinkDTO';
import {CaseHospitalCodingSchemaLinkDTO} from '../../../models/case-hospital/CaseHospitalCodingSchemaLinkDTO';
import {CaseDTO} from '../../../models/CaseDTO';
import {ClaimDisplayDTO} from '../../../models/claim/ClaimDisplayDTO';
import {ProviderFacilityType} from '../../../types/provider-facility-type';
import {DataOverrideService} from '../../../../common/services/data-override.service';
import {ActivityReviewDTO} from '../../../models/claim-review/ActivityReviewDTO';
import {CreateDataColumnDTO, DataColumnDTO} from '../../../../common/models/DataColumnDTO';
import {CreateDataOverrideDTO, DataOverrideDTO} from '../../../../common/models/DataOverrideDTO';
import {PersonNameDTO} from '../../../../ent/models/PersonNameDTO';
import {EditPersonNameDialogComponent} from '../../../../ent/components/dialogs/edit-person-name-dialog/edit-person-name-dialog.component';
import {AdjudicationStatus} from '../../../types/adjudication-status.enum';
import {AddManualPaymentDialogComponent} from '../../dialogs/add-manual-payment-dialog/add-manual-payment-dialog.component';
import {MemberPolicyProductLinkComponent} from '../case-shared-steps/member-policy-product-link/member-policy-product-link.component';
import {CodingSchemaType} from '../../../types/coding-schema-type.enum';
import {UserAuthorisationService} from 'src/app/modules/common/services/user-authorisation.service';
import {DisplayStrings} from 'src/app/modules/common/constants/DisplayStrings';
import {EnvironmentService} from '../../../../common/services/environment-service';
import {PagedResponseDTO} from '../../../../common/models/PagedResponseDTO';
import {CustomValidator} from '../../../../common';
import {getProviderDisplayString} from '../../../common/functions/clm.functions';
import {AddNotesDialogComponent} from '../../../../common/components/dialogs/add-notes-dialog/add-notes-dialog.component';
import {AddObservationDialogComponent} from '../../dialogs/add-observation-dialog/add-observation-dialog.component';
import {ObservationReviewDTO} from '../../../models/claim-review/ObservationReviewDTO';
import {ObservationDTO} from '../../../models/claim/ObservationDTO';
import {ObservationTypeDTO} from '../../../models/claim-review/ObservationyTypeDTO';
import {ObservationService} from '../../../services/observation.service';
import {LookupValue} from '../../../types/lookup-value.enum';
import {ReadOnlyService} from '../../../../common/services/readOnly.service';
import {environment} from '../../../../../../environments/environment';
import {ActivityResultsDialogComponent} from '../../dialogs/activity-results-dialog/activity-results-dialog.component';
import {LoadingSpinnerCounterService} from '../../../../common/services/loading-spinner-counter.service';
import {ActivityOverrideDialogComponent, EncounterOverrideDialogComponent} from '../../dialogs';
import {EntityTable} from '../../../../common/types/entity-table.enum';
import {SharedClmService} from '../../../services/shared-clm.service';
import {ProcessingStatus} from '../../../types/processing-status.enum';
import {AddDocumentDialogComponent} from '../../dialogs/add-document-dialog/add-document-dialog.component';
import {DocumentReviewDTO} from '../../../models/claim-review/DocumentReviewDTO';
import {DocumentDTO} from '../../../models/claim/DocumentDTO';
import {JiraHelperService} from '../../../../common/services/jira-helper.service';
import {JiraService} from '../../../../common/services/jira.service';
import {JiraIssueDTO} from '../../../../common/models/jira/JiraIssueResponseDTO';
import {UserDTO} from '../../../models/user/UserDTO';
import {ActivityInformationDTO} from "../../../models/claim-review/ActivityInformationDTO";
import {ClaimFilterCacheService, ClaimFilterKeys} from '../../../services/claim-filter-cache.service';
import {ClaimType} from '../../../types/claim-type';
import {SearchCriteriaControls} from '../../dialogs/claim-search-criteria-dialog/claim-search-criteria-dialog.component';
import {MatAutocompleteTrigger} from '@angular/material/autocomplete';

const PAGE_SIZE = 50;
const FILTER_PAGE_SIZE = 60;

const DIAGNOSIS_TIER_DATA: NameValueDTO[] = [
  {value: 0, name: 'Primary'},
  {value: 1, name: 'Secondary'}
];

const PROCESSING_CLASS_DATA: NameValueDTO[] = [
  {value: 1, name: 'Medical'},
  {value: 3, name: 'Funeral'}
];

const FUNERAL_PAYEES_DATA: NameValueDTO[] = [
  {value: 9, name: 'Alternative Beneficiary'},
  {value: 10, name: 'Estate'},
  {value: 8, name: 'Nominated Beneficiary'}
];

const MEDICAL_PAYEES_DATA: NameValueDTO[] = [
  {value: 7, name: 'Beneficiary'},
  {value: 3, name: 'Provider'}
];

const BENEFICIARY_NARRATIVE_DATA: NameValueDTO[] = [
  {value: 1, name: 'Nominated beneficiary not set for policy'},
  {value: 2, name: 'Nominated beneficiary has passed'},
  {value: 3, name: 'Order of preference needs to be followed'},
  {value: 4, name: 'Nominated Beneficiary is a suspect in a criminal investigation'},
  {value: 5, name: 'Nominated Beneficiary is in prison'},
  {value: 6, name: 'Nominated Beneficiary is underage'}
];

enum RoutePaths {
  SubmitClaim = 'submit-claim',
  SubmitAuthorisation = 'submit-authorisation',
  ReviewClaim = 'review-claim',
  ReviewAuthorisation = 'review-authorisation',
}

const REQUEST_DATE = 'Request Date';
const AMOUNT_REQUESTED = 'Amount Requested';
const REVIEW_AN_AUTHORISATION = 'Review an Authorisation';
const AMOUNT_CLAIMED = 'Amount Claimed';
const INVOICE_DATE = 'Invoice Date';
const REVIEW_A_CLAIM = 'Review a Claim';
const SUBMIT_AN_AUTHORISATION = 'Submit an Authorisation';
const SUBMIT_A_CLAIM = 'Submit a Claim';
const NO_AUTHORISATION = 'No authorisation associated with this claim';

// Activity Step

enum ActivityControls {
  CodingSchemaType = 'codingSchemaType',
  CodingSchema = 'codingSchema',
  ActivityStartDate = 'activityStartDate',
  ActivityEndDate = 'activityEndDate',
  ActivityStartTime = 'activityStartTime',
  ActivityEndTime = 'activityEndTime',
  ActivityType = 'activityType',
  AmountClaimed = 'amountClaimed',
  AmountBilled = 'amountBilled',
  Quantity = 'quantity',
  DaysSupplied = 'daysSupplied',
  AdjudicationStatus = 'adjudicationStatus',
  Justifications = 'justifications',
  RuleMessages = 'ruleMessages',
  IsCollapsed = 'isCollapsed',
  IsCollapsedRepeatAuthorized = 'IsCollapsedRepeatAuthorized',
  IsReview = 'isReview',
  ActivityId = 'activityId',
  RepeatAuthorised = 'repeatAuthorised',
  Diagnoses = 'diagnoses',
  Observations = 'observations',
  LineOverrideIndicator1 = 'lineOverrideIndicator1',
  LineOverrideIndicator2 = 'lineOverrideIndicator2',
  LineOverrideIndicator3 = 'lineOverrideIndicator3',
  LineOverrideIndicator4 = 'lineOverrideIndicator4',
  ManualCopaymentPercentageOverride = 'manualCopaymentPercentageOverride',
}

@Component({
  selector: 'app-submit-claim-view',
  templateUrl: './submit-claim-view.component.html',
  styleUrls: [
    './submit-claim-view.component.scss',
    '../../../../../../styles/global/_add-view-edit-styles.scss'
  ]
})
export class SubmitClaimViewComponent implements OnInit, OnDestroy, AfterViewChecked, OnDestroy {
  readonly debounceTime = Common.DEBOUNCE_TIME;
  readonly destroyed$ = new Subject();
  readonly providerFacilityType = ProviderFacilityType;
  readonly codingSchemaType = CodingSchemaType;
  readonly AcceptOrRejectAllActivities = 0; // FE value to indicate ACCEPT ALL or REJECT ALL
  readonly ActivityControls = ActivityControls;
  readonly hyphenatedDateFormat = DateUtil.dateFormatWithHyphenated;

  insuredPersonNameFormControl: FormControl;
  processingClassFormControl: FormControl;
  associationOverrideFormControl: FormControl;
  dateOfBirthOverrideFormControl: FormControl;
  genderOverrideFormControl: FormControl;
  idNumberOverrideFormControl: FormControl;
  addNoteFormControl: FormControl;
  consentIndicatorFormControl: FormControl;
  consentReasonFormControl: FormControl;
  /*
    Encounter Step Controls
  */
  providerNameFormControl: FormControl;
  generalCaseFormControl: FormControl;
  encounterTypeFormControl: FormControl;
  encounterStartDateFormControl: FormControl;
  claimReceiveDateFormControl: FormControl;
  encounterEndDateFormControl: FormControl;
  invoiceNumberFormControl: FormControl;
  referenceNumberFormControl: FormControl;
  invoiceDateFormControl: FormControl;
  authorisationNumberFormControl: FormControl;
  referringProviderNameFormControl: FormControl;
  prescribingProviderNameFormControl: FormControl;
  payeeFormControl: FormControl;
  beneficiaryFormControl: FormControl;
  beneficiaryNarrativeFormControl: FormControl;
  claimOverrideIndicator1FormControl: FormControl;

  diagnosisDescriptionFormControl: FormControl;
  diagnosisTierFormControl: FormControl;

  claimFormGroup: FormGroup;
  encounterFormGroup: FormGroup;
  diagnosisFormGroup: FormGroup;
  activityFormGroup: FormGroup;

  selectedInsuredPerson: InsuredPersonDTO;
  selectedInsuredPersonWithDates: InsuredPersonWithDatesDTO;
  selectedBeneficiary: InsuredPersonDTO;
  selectedPolicy: PolicyDTO;
  selectedProduct: ProductDTO;
  filteredInsuredPersons: InsuredPersonDTO[];
  filteredBeneficiaries: InsuredPersonDTO[];
  insuredPersonNameTextChanged = new Subject<string>();
  beneficiaryNameTextChanged = new Subject<string>();
  selectedGeneralCase: any;
  generalCases: any[];

  selectedProvider: ProviderDTO;
  filteredProviders: ProviderDTO[];
  providerNameTextChanged = new Subject<string>();
  providerSearchText: string;

  selectedReferringProvider: ProviderDTO;
  selectedPrescribingProvider: ProviderDTO;
  filteredReferringProviders: ProviderDTO[];
  filteredPrescribingProviders: ProviderDTO[];
  referringProviderSearchText: string;
  prescribingProviderSearchText: string;
  referringProviderNameTextChanged = new Subject<string>();
  prescribingProviderNameTextChanged = new Subject<string>();

  authorisations: ClaimDisplayDTO[];

  selectedDiagnoses: DiagnosisDTO[];
  filteredDiagnoses: DiagnosisDTO[];
  diagnosisDescriptionTextChanged = new Subject<string>();

  filteredCodingSchemas: CodingSchemaDTO[];
  selectedCodingSchemas: CodingSchemaDTO[];
  codingSchemaDescriptionTextChanged = new Subject<string>();

  processingClasses: NameValueDTO[];
  selectedEncounterType: NameValueDTO;
  encounterTypes: NameValueDTO[];
  selectedPayee: NameValueDTO;
  allPayees: NameValueDTO[];
  funeralPayees: NameValueDTO[];
  medicalPayees: NameValueDTO[];
  beneficiaryNarratives: NameValueDTO[];
  adjudicationStatuses: NameValueDTO[];
  diagnosisTiers: NameValueDTO[];
  activityTypes: NameValueDTO[];
  codingSchemaTypes: NameValueDTO[];
  codingSchemaTypesFuneral: NameValueDTO[];
  associations: NameValueDTO[];
  genders: NameValueDTO[];
  consentReasons: NameValueDTO[];
  observationTypes: ObservationTypeDTO[];

  dateFormat = DateUtil.dateFormat;
  heading: string;
  backPageName: string;
  selectedProcessingClass: string;
  invoiceDateLabel: string;
  encounterStartDateLabel: string;
  amountClaimedLabel: string;
  memberNameLabel: string;
  providerNameLabel: string;
  beneficiaryHeading: string;
  activityStartDateLabel: string;
  isClaim: boolean; // true = claim; false = authorisation
  isReview: boolean;
  isFuneral: boolean;
  isNominatedBeneficiary: boolean;
  isEstate: boolean;
  isAlternativeBeneficiary: boolean;
  isAdjudicationStatusUpdated: boolean;
  isEditMode: boolean;
  activitiesCount = 1;
  activitiesAmount = 0.0;
  noOfConsultationVisits: number;
  claimReview: ClaimReviewDTO;
  returnMessage: ReturnMessageDTO;
  documents: DocumentReviewDTO[];
  jiraEnabled = false;
  containsJiraKey = false;
  jiraKeyExists = false;
  jiraKey: string;
  jiraUrl: string;
  jiraIssue: JiraIssueDTO;
  referenceNumberPlaceholderText: string;

  editPersonName: boolean;
  editDateOfBirth: boolean;
  editAssociation: boolean;
  editGender: boolean;
  editIdNumber: boolean;

  userRoles: string[];
  userFirstLastName = '';
  dynamicDateTitle: string;
  practiceNumber: string; // Note: username will act as practice no for General practitioners in Provider Portal
  isProviderPortal = false;
  allowGeneralPractitionerDrugsOnly = false;
  isPrimarySubClassPharmacy: boolean;
  requireCaseToCaptureTransaction: boolean;
  isDispensingProvider: boolean;
  isMemberPolicyProductFormValid: boolean;
  isReadModeEnabled: boolean;
  isImportedTransaction: boolean;
  hasOpenAuthorisations = signal(false);
  openAuthorisationLookupFailed = signal(false);

  private openAuthorisationLookupSequence = 0;
  // Feature Flags
  isAllowSubmitClaimForNormalPortal: boolean;
  isAllowSubmitAuthForNormalPortal: boolean;
  isAllowSubmitClaimForProviderPortal: boolean;
  isAllowSubmitAuthForProviderPortal: boolean;

  @ViewChild('memberPolicyProductLink', {static: false}) private memberPolicyProductLink: MemberPolicyProductLinkComponent;

  @ViewChild('stepper') private claimSubmissionStepper: MatStepper;
  @ViewChild('claimStep', {static: false}) private claimStep: MatStep;
  @ViewChild('encounterStep', {static: false}) private encounterStep: MatStep;
  @ViewChild('diagnosisStep', {static: false}) private diagnosisStep: MatStep;
  @ViewChild('activityStep', {static: false}) private activityStep: MatStep;
  @ViewChild('activityBackButton', {static: false}) private activityBackButton: MatButton;
  @ViewChild('activityClearButton', {static: false}) private activityClearButton: MatButton;
  @ViewChild('finishButton', {static: false}) private finishButton: MatButton;
  @ViewChild('addNoteButton', {static: false}) private addNoteButton: MatButton;
  @ViewChild('addDocumentButton', {static: false}) private addDocumentButton: MatButton;
  @ViewChild('addActivityButton', {static: false}) private addActivityButton: MatButton;
  @ViewChild('acceptAllButton', {static: false}) private acceptAllButton: MatButton;
  @ViewChild('rejectAllButton', {static: false}) private rejectAllButton: MatButton;
  @ViewChild('skipPaymentButton', {static: false}) private skipPaymentButton: MatButton;

  constructor(
    public dialog: MatDialog,
    public datePipe: DatePipe,
    private changeDetect: ChangeDetectorRef,
    private formBuilder: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private claimService: ClaimService,
    private readOnlyService: ReadOnlyService,
    private environmentService: EnvironmentService,
    private insuredPersonService: InsuredPersonService,
    private providerService: ProviderService,
    private caseService: CaseService,
    private diagnosisService: DiagnosisService,
    private lookupService: LookupService,
    private codingSchemaService: CodingSchemaService,
    private claimReviewService: ClaimReviewService,
    private assessmentNarrativeService: AssessmentNarrativeService,
    private ruleMessageService: RuleMessageService,
    private router: Router,
    private sharedService: SharedService,
    private sharedClmService: SharedClmService,
    private dataOverrideService: DataOverrideService,
    private userAuthorisationService: UserAuthorisationService,
    private observationService: ObservationService,
    private loadingSpinnerCounterService: LoadingSpinnerCounterService,
    private jiraHelperService: JiraHelperService,
    private jiraService: JiraService,
    private claimFilterCacheService: ClaimFilterCacheService
  ) {
    // Initialise Variables
    this.generalCases = [];
    this.authorisations = [];
    this.selectedCodingSchemas = [];
    this.selectedDiagnoses = [];
    this.filteredProviders = [];
    this.filteredReferringProviders = [];
    this.filteredPrescribingProviders = [];
    this.documents = [];

    // TODO: Use lookup service
    this.diagnosisTiers = DIAGNOSIS_TIER_DATA;
    this.processingClasses = PROCESSING_CLASS_DATA;
    this.funeralPayees = FUNERAL_PAYEES_DATA;
    this.medicalPayees = MEDICAL_PAYEES_DATA;
    this.beneficiaryNarratives = BENEFICIARY_NARRATIVE_DATA;

    this.isReadModeEnabled = this.readOnlyService.readOnlyTransactions;
    this.isAllowSubmitClaimForNormalPortal = this.environmentService.isAllowedToSubmitClaimForNormalPortal();
    this.isAllowSubmitAuthForNormalPortal = this.environmentService.isAllowedToSubmitAuthForNormalPortal();
    this.isAllowSubmitClaimForProviderPortal = this.environmentService.isAllowedToSubmitClaimForProviderPortal();
    this.isAllowSubmitAuthForProviderPortal = this.environmentService.isAllowedToSubmitAuthForProviderPortal();
    this.isImportedTransaction = false;

    this.backPageName = 'claim-management';
    this.isNominatedBeneficiary = false;
    this.isEstate = false;
    this.isAlternativeBeneficiary = false;
    this.isAdjudicationStatusUpdated = false;
    this.selectedProcessingClass = CaseType.Medical;
    this.isPrimarySubClassPharmacy = this.environmentService.isPrimarySubClassPharmacy();
    this.requireCaseToCaptureTransaction = this.environmentService.requireCaseToCaptureTransaction();
    this.isDispensingProvider = this.environmentService.isDefaultDispensingProvider();
    this.jiraEnabled = this.environmentService.isJiraApiEnabled();
    if (this.jiraEnabled) {
      this.referenceNumberPlaceholderText = `Enter a Jira key e.g. ${this.environmentService.getJiraApiKeyPrefix()}-123`;
    }

    // Note:
    // Checking Route static data that is passed to child routes

    const parentData = this.activatedRoute.parent?.snapshot.data;
    this.isProviderPortal = parentData?.providerPortal;
    this.allowGeneralPractitionerDrugsOnly = environment.allowGeneralPractitionerDrugsOnly;
    this.dynamicDateTitle = this.isProviderPortal ? 'Receive Date' : 'Claim Receive Date'; // default value

    this.setVariablesByUrl();
    this.setVariablesByProcessingClass(this.selectedProcessingClass);

    // Initialise Form Controls
    this.initFormControls();
    this.updateValidators();

    // Initialise Form Groups
    this.initFormGroups();
    this.addActivityFormGroup();
    this.setDiagnosisTier();
    this.initSubscriptions();

    this.editPersonName = false;
    this.editDateOfBirth = false;
    this.editAssociation = false;
    this.editGender = false;
  }

  asFormGroup(control: AbstractControl): FormGroup {
    return control as FormGroup;
  }

  get isNormalPortal(): boolean {
    return !this.isProviderPortal;
  }

  get requiresCaseToCaptureTransaction(): boolean {
    // A case is always required for funeral transactions
    // Otherwise, a case is required only when turned on AND when captured via normal portal
    // By default, for provider portal, case is always not required
    // This applies to claims and authorisations alike
    return this.isFuneral || (this.isNormalPortal && this.requireCaseToCaptureTransaction);
  }

  get bannerText(): string {
    let bannerText = DisplayStrings.permissionsErrorMessages.cannotEditTransaction;
    if (this.isImportedTransaction) {
      bannerText = DisplayStrings.permissionsErrorMessages.cannotEditImportedTransaction;
    } else if (this.isClaim) {
      bannerText = DisplayStrings.permissionsErrorMessages.cannotEditClaim;
    } else if (this.isAuthorisation()) {
      bannerText = DisplayStrings.permissionsErrorMessages.cannotEditAuthorisation;
    }
    return bannerText;
  }

  get activityFormArray(): FormArray {
    return this.activityFormGroup ? this.activityFormGroup.get('activityFormArray') as FormArray : null;
  }

  get processButtonLabel(): string {
    return this.isReview ? 'Reprocess' : 'Process';
  }

  get isAuthorisedToSubmitAndReviewTransactions(): boolean {
    return this.userAuthorisationService.hasRoleToSubmitAndReviewTransactions();
  }

  initFormControls(): void {
    this.processingClassFormControl = new FormControl(this.selectedProcessingClass, [Validators.required]);
    this.claimReceiveDateFormControl = new FormControl(new Date(), [Validators.required]);
    this.insuredPersonNameFormControl = new FormControl('', this.requiresCaseToCaptureTransaction ? [Validators.required ] : []);
    this.generalCaseFormControl = new FormControl('', this.requiresCaseToCaptureTransaction ? [Validators.required ] : []);
    this.associationOverrideFormControl = new FormControl(''); // required when editing only
    this.dateOfBirthOverrideFormControl = new FormControl(''); // required when editing only
    this.genderOverrideFormControl = new FormControl(''); // required when editing only
    this.idNumberOverrideFormControl = new FormControl(''); // required when editing only
    this.addNoteFormControl = new FormControl(''); // Capture note for claims/auth
    this.consentIndicatorFormControl = new FormControl(false);
    this.consentReasonFormControl = new FormControl(null);

    this.providerNameFormControl = new FormControl('', [Validators.required]);
    this.encounterTypeFormControl = new FormControl('In-patient', [Validators.required]);
    this.encounterStartDateFormControl = new FormControl(new Date(), [Validators.required]);
    this.encounterEndDateFormControl = new FormControl();
    this.invoiceNumberFormControl = new FormControl('');
    this.referenceNumberFormControl = new FormControl('');
    this.invoiceDateFormControl = new FormControl(new Date()); // required by medical only
    this.authorisationNumberFormControl = new FormControl(''); // required by medical claim only
    this.referringProviderNameFormControl = new FormControl('');
    this.prescribingProviderNameFormControl = new FormControl('');
    this.payeeFormControl = new FormControl('', [Validators.required]);
    this.beneficiaryNarrativeFormControl = new FormControl(''); // required for estate and alternative beneficiary only
    this.claimOverrideIndicator1FormControl = new FormControl(false);
    this.beneficiaryFormControl = new FormControl(''); // required for estate and alternative beneficiary only
    this.diagnosisDescriptionFormControl = new FormControl('');
    this.diagnosisTierFormControl = new FormControl('Primary');
  }

  initFormGroups(): void {
    this.claimFormGroup = this.formBuilder.group({
      insuredPersonName: this.insuredPersonNameFormControl,
      funeralCase: this.generalCaseFormControl,
      processingClass: this.processingClassFormControl,
      claimReceiveDate: this.claimReceiveDateFormControl,
      associationOverride: this.associationOverrideFormControl,
      dateOfBirthOverride: this.dateOfBirthOverrideFormControl,
      genderOverride: this.genderOverrideFormControl,
      idNumberOverride: this.idNumberOverrideFormControl
    }, {validator: this.overridesSavedValidator()}
    );

    this.encounterFormGroup = this.formBuilder.group({
        provider: this.providerNameFormControl,
        encounterType: this.encounterTypeFormControl,
        encounterStartDate: this.encounterStartDateFormControl,
        encounterEndDate: this.encounterEndDateFormControl,
        invoiceNumber: this.invoiceNumberFormControl,
        referenceNumber: this.referenceNumberFormControl,
        invoiceDate: this.invoiceDateFormControl,
        authorisationNumber: this.authorisationNumberFormControl,
        referringProviderName: this.referringProviderNameFormControl,
        prescribingProviderName: this.prescribingProviderNameFormControl,
        payTo: this.payeeFormControl,
        beneficiaryNarrative: this.beneficiaryNarrativeFormControl,
        beneficiary: this.beneficiaryFormControl,
        claimOverrideIndicator1claimOverrideIndicator1: this.claimOverrideIndicator1FormControl
      }, {validator: [this.beneficiarySelectedValidator(), this.beneficiaryDifferentToMemberValidator()]}
    );

    this.diagnosisFormGroup = this.formBuilder.group({
        diagnosis: this.diagnosisDescriptionFormControl,
        diagnosisTier: this.diagnosisTierFormControl
      }, {validator: [this.primaryDiagnosisSelectedValidator(), this.minimumDiagnosesValidator()]}
    );

    this.activityFormGroup = this.formBuilder.group({
      activityFormArray: this.formBuilder.array([])
    });
    this.activityFormGroup.setValidators(this.minimumActivitiesValidator());
  }

  initSubscriptions(): void {
    this.insuredPersonNameTextChanged
      .pipe(debounceTime(this.debounceTime), takeUntil(this.destroyed$))
      .subscribe(searchText => {
        this.filteredInsuredPersons = [];
        this.getFilteredListOfInsuredPersons(searchText);
      });

    this.beneficiaryNameTextChanged
      .pipe(debounceTime(this.debounceTime), takeUntil(this.destroyed$))
      .subscribe(searchText => {
        this.filteredBeneficiaries = [];
        this.getFilteredListOfBeneficiaries(searchText, this.isEstate);
      });

    this.providerNameTextChanged
      .pipe(debounceTime(this.debounceTime), takeUntil(this.destroyed$))
      .subscribe(searchText => {
        this.providerSearchText = searchText;
        this.filteredProviders = [];
        this.getFilteredListOfProviders(searchText);
      });

    this.referringProviderNameTextChanged
      .pipe(debounceTime(this.debounceTime), takeUntil(this.destroyed$))
      .subscribe(searchText => {
        this.referringProviderSearchText = searchText;
        this.filteredReferringProviders = [];
        this.getFilteredListOfProviders(searchText, true);
      });

    this.prescribingProviderNameTextChanged
      .pipe(debounceTime(this.debounceTime), takeUntil(this.destroyed$))
      .subscribe(searchText => {
        this.prescribingProviderSearchText = searchText;
        this.filteredPrescribingProviders = [];
        this.getFilteredListOfProviders(searchText, false, true);
      });

    this.diagnosisDescriptionTextChanged
      .pipe(debounceTime(this.debounceTime), takeUntil(this.destroyed$))
      .subscribe(searchText => {
        this.filteredDiagnoses = [];
        this.getFilteredListOfDiagnoses(searchText);
      });

    this.codingSchemaDescriptionTextChanged
      .pipe(debounceTime(this.debounceTime), takeUntil(this.destroyed$))
      .subscribe(searchString => {
        this.filteredCodingSchemas = [];
        this.getFilteredListOfCodingSchemasByField(searchString);
      });

    this.editPersonName = false;
    this.editDateOfBirth = false;
    this.editAssociation = false;
    this.editGender = false;
    this.editIdNumber = false;
    this.observationTypes = [];
  }

  ngOnInit(): void {
    const currentPath: string = this.activatedRoute.snapshot.routeConfig.path;
    this.getListOfLookupValues().pipe(
      switchMap(_ => {
        const loggedInProfile$: Observable<UserDTO> = this.sharedService.getLoggedInUserProfile$().pipe(take(1));
        return combineLatest([loggedInProfile$, this.activatedRoute.params]);
      }),
      switchMap(([profile, params]: [UserDTO, Params]) => {
        this.isEditMode = currentPath.includes('review');
        this.userFirstLastName = this.sharedService.getLoggedInUserName();
        this.practiceNumber = this.sharedService.getProfileLinkedEntityCode(); // will be considered as practiceNo for Provider Portal
        return iif(() => !!this.isEditMode, this.getClaimReview(params.id), of({ response: null }))
          .pipe(
            catchError((error) => {
              return throwError(() =>  error);
            })
          );
      }),
      switchMap(({response}) => {
        if (currentPath.includes('review') && !this.isProviderPortal) {
          this.handleClaimReviewEdit(response);
        }
        else if (this.isProviderPortal) {
          this.handleAddOrEditProviderPortalChanges(response);
        }
        else {
          this.handleAddForNormalPortal();
        }
        return of({response});
      }),
      switchMap(({response}) => {
        const insuredPersonId: number = (response as ClaimReviewDTO)?.insuredPerson?.insuredPersonDTO?.insuredPersonId;
        return iif(
          () => !!this.isEditMode && !!insuredPersonId,
          this.sharedClmService.getConsultationVisitsBy(insuredPersonId),
          of({response: null})
        )
          .pipe(
            catchError((errorResponse) => {
              return of(errorResponse);
            })
          );
      })
    ).subscribe({
      next: ({visits}: { visits: number }) => {
        this.noOfConsultationVisits = visits;
      },
      error: ({error}) => {
        console.error('Error:', error);
        this.sharedService.openErrorDialog(error);
      }
    });

    this.observationService.getAllObservationTypes()
      .pipe(takeUntil(this.destroyed$))
      .subscribe(observationTypes => {
      this.observationTypes = observationTypes;
    });

    this.sharedService.getHelpInfo('claim');
  }

  handleAddOrEditProviderPortalChanges(response: ClaimReviewDTO | null): void {
    const currentPath: string = this.activatedRoute.snapshot.routeConfig.path;

    // Requirement: set Provider name in case of PP user
    this.getProviderByPracticeNumber(this.practiceNumber)
      .pipe(
        take(1)
      )
      .subscribe({
        next: ({provider}) => {
        // Case: Edit (Claim/Authorisation)
          if (currentPath.includes('review')) {
            this.handleClaimReviewEdit(response);
          }
          else {
            // Case: Add (Claim/Authorisation)
            // Special requirement we need to set 'Provider Name & Pay To' in add case.
            this.selectedProvider = provider;
            this.providerNameFormControl.setValue(this.getProviderDisplayString(this.selectedProvider));
            this.updatePrescribingProviderValidation();
            this.payeeFormControl.setValue('Provider');

            // Set encounter type
            this.encounterTypeFormControl.setValue('Out-patient');
            this.onEncounterTypeSelectionChanged('Out-patient');
          }
        },
        error: (error) => console.error('Error:', error)
      });
  }

  handleClaimReviewEdit(claimReviewDTO: ClaimReviewDTO): void {
    this.claimReview = claimReviewDTO;
    this.documents = claimReviewDTO.documents;
    this.isReadModeEnabled = this.readOnlyService.isTransactionReadOnly(this.claimReview.processingStatus?.name as ProcessingStatus);
    this.isImportedTransaction = this.claimReview?.createdBy?.toUpperCase() == 'SYSTEM';

    // If the insured person is null (i.e. the policy - person - product link on the transaction is no longer valid)
    if (this.claimReview.insuredPerson == null) {
      this.handleUpdatedPolicyData();
    }
    else {
      this.setFormsForEdit(this.claimReview);
    }
  }

  handleAddForNormalPortal(): void {
    if (this.isDispensingProvider) {
      const searchPharmacyDirectProvider: string = this.environmentService.getPharmacyDirectNumber();
      this.providerNameTextChanged.next(searchPharmacyDirectProvider);

      this.getProviderByPracticeNumber(searchPharmacyDirectProvider)
        .pipe(
          take(1)
        )
        .subscribe({
          next: ({provider}) => {
            if (provider) {
              this.selectedProvider = provider;
              this.providerNameFormControl.setValue(this.getProviderDisplayString(this.selectedProvider));
              this.updatePrescribingProviderValidation();
            }
          },
          error: (err) => console.error('Error:', err)
        });
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  ngAfterViewChecked(): void {
    this.changeDetect.detectChanges();
  }

  /*
  * VALIDATORS
  */

  overridesSavedValidator(): ValidatorFn {
    return (group: FormGroup): { [key: string]: any } | null => {
      return !this.editPersonName && !this.editDateOfBirth && !this.editAssociation && !this.editGender && !this.editIdNumber ? null : {overridesSaved: true};
    };
  }

  beneficiarySelectedValidator(): ValidatorFn {
    return (group: FormGroup): { [key: string]: any } | null => {
      const beneficiary: InsuredPersonDTO = this.selectedBeneficiary;
      const selectedPayee: string = group.get('payTo').value;
      let isSelected = true;
      if (selectedPayee === 'Nominated Beneficiary' || selectedPayee === 'Estate' || selectedPayee === 'Alternative Beneficiary') {
        if (beneficiary == null) {
          isSelected = false;
        }
      }
      return isSelected ? null : {beneficiarySelected: true};
    };
  }

  beneficiaryDifferentToMemberValidator(): ValidatorFn {
    return (group: FormGroup): { [key: string]: any } | null => {
      const beneficiary: InsuredPersonDTO = this.selectedBeneficiary;
      const member: InsuredPersonDTO = this.selectedInsuredPerson;
      const selectedPayee: string = group.get('payTo').value;
      let isDifferent = true;
      if (selectedPayee === 'Nominated Beneficiary' || selectedPayee === 'Estate' || selectedPayee === 'Alternative Beneficiary') {
        if (beneficiary != null && member != null && beneficiary.insuredPersonId == member.insuredPersonId) {
          isDifferent = false;
        }
      }
      return isDifferent ? null : {beneficiaryDifferentToMember: true};
    };
  }

  minimumDiagnosesValidator(): ValidatorFn {
    const diagnoses: DiagnosisDTO[] = this.selectedDiagnoses;
    return (group: FormGroup): { [key: string]: any } | null => {
      return diagnoses && diagnoses.length > 0 ? null : {minimumDiagnoses: true};
    };
  }

  primaryDiagnosisSelectedValidator(): ValidatorFn {
    return (group: FormGroup): { [key: string]: any } | null => {
      const diagnoses: DiagnosisDTO[] = this.selectedDiagnoses;
      let isPrimary = false;
      if (diagnoses) {
        diagnoses.forEach(diagnosis => {
          if (diagnosis.icdTier === 'Primary' && (diagnosis.validIcd10Primary === 'Y' || this.isFuneral)) {
            isPrimary = true;
          }
        });
      }
      return isPrimary ? null : {primaryDiagnosisSelected: true};
    };
  }

  minimumActivitiesValidator(): ValidatorFn {
    const activities: FormArray = this.activityFormArray;
    return (group: FormGroup): { [key: string]: any } | null => {
      return activities && activities.controls.length > 0 ? null : {minimumActivities: true};
    };
  }

  /*
  * PAGE METHODS
  */

  getInfoTooltip(inputName: string): string {
    return this.sharedService.getInfoTooltip(inputName);
  }

  isPrimarySelectedOnlyOneAllowed(): boolean {
    let isPrimary = false;
    if (this.selectedDiagnoses) {
      this.selectedDiagnoses.forEach(diagnosis => {
        if (diagnosis.icdTier === 'Primary') {
          isPrimary = true;
        }
      });
    }
    return isPrimary && !this.isPrimarySubClassPharmacy;
  }

  isFinishButtonDisabled(): boolean {
    let isDisabled = false;

    if (!this.isAllowedToSubmitTransaction()) {
      isDisabled = true;
    }
    else if (this.activityFormGroup.invalid) {
      isDisabled = true;
    }
    else if (this.loadingSpinnerCounterService.isLoading()) {
      isDisabled = true;
    }
    return isDisabled;
  }


  isAllowedToSubmitTransaction(): boolean {
    let hasAccessToSubmitTransaction = false;

    if (this.isReadModeEnabled) {
      hasAccessToSubmitTransaction = false;
    }
    else if (this.isProviderPortal) {
      if (this.isClaim) {
        hasAccessToSubmitTransaction = this.isAllowSubmitClaimForProviderPortal;
      }
      else if (this.isAuthorisation()) {
        hasAccessToSubmitTransaction = this.isAllowSubmitAuthForProviderPortal;
      }
    }
    else {
      if (this.isClaim) {
        hasAccessToSubmitTransaction = this.isAllowSubmitClaimForNormalPortal;
      }
      else if (this.isAuthorisation()) {
        hasAccessToSubmitTransaction = this.isAllowSubmitAuthForNormalPortal;
      }
    }

    return this.isAuthorisedToSubmitAndReviewTransactions && hasAccessToSubmitTransaction;
  }

  getFinishButtonTooltip(): string {
    if (!this.isAuthorisedToSubmitAndReviewTransactions) {
      return DisplayStrings.permissionsErrorMessages.rolePermissionSubmitTransaction;
    }
    else if (!this.isAllowedToSubmitTransaction()) {
      return this.bannerText;
    }
    else {
      return 'There are one or more activities missing information - identify them with the warning icon';
    }
  }

  getClearButtonTooltip(): string {
    if (!this.isAuthorisedToSubmitAndReviewTransactions) {
      return DisplayStrings.permissionsErrorMessages.rolePermissionClearData;
    }
    else if (!this.isAllowedToSubmitTransaction()) {
      return DisplayStrings.permissionsErrorMessages.cannotClearData;
    }
    return null;
  }

  blurInsuredPersonName(): void {
    if (
      this.filteredInsuredPersons &&
      this.filteredInsuredPersons.find(
        (item) => this.getInsuredPersonDisplayString(item) === this.insuredPersonNameFormControl.value
      ) == null
    ) {
      this.insuredPersonNameFormControl.reset();
      this.selectedInsuredPerson = null;
      this.invalidateOpenAuthorisationLookup();
    }
  }

  blurBeneficiaryName(): void {
    if (
      this.filteredBeneficiaries &&
      this.filteredBeneficiaries.find(
        (item) => this.getInsuredPersonDisplayString(item) === this.beneficiaryFormControl.value
      ) == null
    ) {
      this.beneficiaryFormControl.reset();
      this.selectedBeneficiary = null;
    }
  }

  onInputChangedSearchInsuredPersons($event): void {
    this.insuredPersonNameTextChanged.next($event.target.value);
  }

  onInputChangedSearchBeneficiaries($event): void {
    this.beneficiaryNameTextChanged.next($event.target.value);
  }

  onInsuredPersonOptionChanged(name: string): void {
    if (this.filteredInsuredPersons) {
      this.selectedInsuredPerson = this.filteredInsuredPersons.find((item) => name === this.getInsuredPersonDisplayString(item));

      const insuredPersonId: number = this.selectedInsuredPerson.insuredPersonId;
      this.getInsuredPersonCases(insuredPersonId);
      this.sharedClmService.getConsultationVisitsBy(insuredPersonId)
        .pipe(
          take(1),
          catchError((errorResponse) => {
            return of(errorResponse);
          })
        ).subscribe({
        next: ({visits}) => {
          this.noOfConsultationVisits = visits;
        },
      });
    }
    this.clearCaseGeneral();
    if (this.isClaim && !this.isFuneral) {
      this.getListOfAcceptedAuthorisationsForPerson();
    }

    this.checkForOpenAuthorisations();
  }

  onSelectedInsuredPersonNotifiedFromPP(isInsuredPersonSelected: boolean): void {
    if (!isInsuredPersonSelected) {
      this.invalidateOpenAuthorisationLookup();
      return;
    }

    // We need to fetch authorization to update ddn values in case of "Submit Claim"
    // as it is *required for claim in case of PP because we are using "SEP" component for
    // Provider Portal
    this.setPayloadFieldsForMembershipFromUserSelection();

    if (this.isClaim && !this.isFuneral) {
      this.getListOfAcceptedAuthorisationsForPerson();
    }

    this.checkForOpenAuthorisations();
  }

  private checkForOpenAuthorisations(): void {
    const lookupSequence = ++this.openAuthorisationLookupSequence;

    this.hasOpenAuthorisations.set(false);
    this.openAuthorisationLookupFailed.set(false);

    if (
      this.isClaim ||
      this.isReview ||
      this.isProviderPortal ||
      this.isFuneral ||
      !this.selectedInsuredPerson
    ) {
      return;
    }

    const personId = this.selectedInsuredPerson.insuredPersonId;

    this.claimService.hasOpenAuthorisations(personId)
      .pipe(take(1))
      .subscribe({
        next: (hasOpenAuthorisations: boolean) => {
          if (
            this.openAuthorisationLookupSequence === lookupSequence &&
            this.selectedInsuredPerson?.insuredPersonId === personId
          ) {
            this.hasOpenAuthorisations.set(hasOpenAuthorisations);
            this.openAuthorisationLookupFailed.set(false);
          }
        },
        error: () => {
          if (
            this.openAuthorisationLookupSequence === lookupSequence &&
            this.selectedInsuredPerson?.insuredPersonId === personId
          ) {
            this.hasOpenAuthorisations.set(false);
            this.openAuthorisationLookupFailed.set(true);
          }
        }
      });
  }

  private invalidateOpenAuthorisationLookup(): void {
    ++this.openAuthorisationLookupSequence;
    this.hasOpenAuthorisations.set(false);
    this.openAuthorisationLookupFailed.set(false);
  }

  viewAuthorisations(): void {
    const membershipNumber = this.selectedInsuredPerson?.cardNumber;

    const filterValues = {
      [ClaimFilterKeys.ClaimType]: ClaimType.APPROVAL,
      [ClaimFilterKeys.PageNumber]: 0,
      ...(membershipNumber ? {
        [ClaimFilterKeys.SearchClaims]: membershipNumber,
        // ClaimsComponent.transactionsSearchFilters maps this criterion to insuredPersonByInsuredPersonId.cardNumber, despite its name.
        [ClaimFilterKeys.SearchCriteria]: [SearchCriteriaControls.PolicyNumber]
      } : {})
    };

    this.claimFilterCacheService.replaceFilterValues(filterValues);
    this.router.navigate(['/claim-management'], {queryParams: {tab: 'claims'}});
  }


  onBeneficiaryOptionChanged(name: string): void {
    if (this.filteredBeneficiaries) {
      this.selectedBeneficiary = this.filteredBeneficiaries.find((item) => name === this.getInsuredPersonDisplayString(item));
    }
  }

  encounterStartDateChanged(): void {
    if (this.encounterEndDateRequired() && (this.encounterEndDateFormControl.value == '' || this.encounterEndDateFormControl.value == null)
    ) {
      this.encounterEndDateFormControl.setValue(new Date(this.encounterStartDateFormControl.value));
    }
  }

  processingClassSelected(name: string): void {
    this.processingClassFormControl.setValue(name);
    this.selectedProcessingClass = name;
    this.updateValidatorsByProcessingClass(name);
    this.setVariablesByProcessingClass(name);
  }

  onProcessingClassSelectionChanged(name: string): void {
    this.resetClaimFormGroup();
    this.resetEncounterFormGroup();
    this.resetActivityFormGroup();
    this.resetDiagnosisFormGroup();
    this.processingClassSelected(name);
    if (this.selectedInsuredPerson) {
      this.onInsuredPersonOptionChanged(this.getInsuredPersonDisplayString(this.selectedInsuredPerson));
    }
  }

  blurProviderName(): void {
    if (
      this.filteredProviders &&
      this.filteredProviders.find(
        (item) => this.getProviderDisplayString(item) === this.providerNameFormControl.value
      ) == null
    ) {
      this.providerNameFormControl.reset();
      this.selectedProvider = null;
      this.updatePrescribingProviderValidation();
    }
  }

  onBlurReferringProviderName(): void {
    const isFound: boolean = this.filteredReferringProviders.some(
      (item: ProviderDTO): boolean => this.getProviderDisplayString(item) === this.referringProviderNameFormControl.value
    );

    if (!isFound) {
      this.referringProviderNameFormControl.reset();
      this.selectedReferringProvider = null;
    }
  }

  onBlurPrescribingProviderName(): void {
    const isFound: boolean = this.filteredPrescribingProviders.some(
      (item: ProviderDTO): boolean => this.getProviderDisplayString(item) === this.prescribingProviderNameFormControl.value
    );

    if (!isFound) {
      this.prescribingProviderNameFormControl.reset();
      this.selectedPrescribingProvider = null;
    }
  }

  onInputChangedSearchProviders($event): void {
    this.providerNameTextChanged.next($event.target.value);
  }

  onInputChangedSearchReferringProviders($event): void {
    this.referringProviderNameTextChanged.next($event.target.value);
  }

  onInputChangedSearchPrescribingProviders($event): void {
    this.prescribingProviderNameTextChanged.next($event.target.value);
  }

  onProviderEnter(event?: Event, autocompleteTrigger?: MatAutocompleteTrigger): void {
    if (autocompleteTrigger?.panelOpen && autocompleteTrigger.activeOption) {
      return;
    }
    event?.preventDefault();
    this.selectExactPracticeNumberProvider(this.providerNameFormControl.value, this.filteredProviders, this.providerSearchText, false, false, autocompleteTrigger);
  }

  onReferringProviderEnter(event?: Event, autocompleteTrigger?: MatAutocompleteTrigger): void {
    if (autocompleteTrigger?.panelOpen && autocompleteTrigger.activeOption) {
      return;
    }
    event?.preventDefault();
    this.selectExactPracticeNumberProvider(this.referringProviderNameFormControl.value, this.filteredReferringProviders, this.referringProviderSearchText, true, false, autocompleteTrigger);
  }

  onPrescribingProviderEnter(event?: Event, autocompleteTrigger?: MatAutocompleteTrigger): void {
    if (autocompleteTrigger?.panelOpen && autocompleteTrigger.activeOption) {
      return;
    }
    event?.preventDefault();
    this.selectExactPracticeNumberProvider(this.prescribingProviderNameFormControl.value, this.filteredPrescribingProviders, this.prescribingProviderSearchText, false, true, autocompleteTrigger);
  }

  private selectExactPracticeNumberProvider(
    searchValue: string,
    providers: ProviderDTO[],
    resultsSearchText: string,
    isReferring = false,
    isPrescribing = false,
    autocompleteTrigger?: MatAutocompleteTrigger
  ): void {
    const practiceNumber = `${searchValue ?? ''}`.trim();
    const availableProviders = providers ?? [];
    if (this.isSelectedProviderOption(practiceNumber, availableProviders)) {
      return;
    }

    const exactMatches = availableProviders.filter(
      (provider: ProviderDTO) => provider.practiceNumber?.trim() === practiceNumber
    );

    if (exactMatches.length === 1) {
      this.providerSelected(exactMatches[0].providerId, isReferring, isPrescribing);
      autocompleteTrigger?.closePanel();
      return;
    }

    if (!practiceNumber) {
      return;
    }

    const resultsAreCurrent = `${resultsSearchText ?? ''}`.trim() === practiceNumber;
    if (availableProviders.length > 0 && resultsAreCurrent) {
      return;
    }

    this.lookupExactPracticeNumberProvider(practiceNumber, isReferring, isPrescribing, autocompleteTrigger);
  }

  /**
   * MatAutocompleteTrigger handles Enter before our listener, so by the time it runs an option may
   * already be selected and the control holds that option's display string.
   */
  private isSelectedProviderOption(value: string, providers: ProviderDTO[]): boolean {
    return (providers ?? []).some((provider: ProviderDTO) => this.getProviderDisplayString(provider) === value);
  }

  private lookupExactPracticeNumberProvider(
    practiceNumber: string,
    isReferring = false,
    isPrescribing = false,
    autocompleteTrigger?: MatAutocompleteTrigger
  ): void {
    this.providerService.getListOfProviders(this.buildExactPracticeNumberProviderSearchRequest(practiceNumber))
      .pipe(take(1))
      .subscribe({
        next: (response: PagedResponseDTO<ProviderDTO>) => {
          const exactMatches = (response?.resultList ?? []).filter(
            (provider: ProviderDTO) => provider.practiceNumber?.trim() === practiceNumber
          );
          if (exactMatches.length === 1) {
            this.providerSelected(exactMatches[0].providerId, isReferring, isPrescribing);
            autocompleteTrigger?.closePanel();
          }
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  onProviderOptionChanged(name: string): void {
    if (this.filteredProviders) {
      const provider = this.filteredProviders.find((item) => name === this.getProviderDisplayString(item));
      this.providerSelected(provider.providerId);
    }
  }

  onGeneralCaseSelectionChanged(name: string): void {
    if (this.generalCases) {
      this.selectedGeneralCase = this.generalCases.find((item) => name === this.getCaseDisplayString(item));
    }
    if (this.selectedGeneralCase) {
      this.clearBeneficiaryName();
      this.selectedPolicy = this.selectedGeneralCase.caseDTO.policy;
      this.selectedProduct = this.selectedGeneralCase.caseDTO.product;
      this.getInsuredPersonWithDates(this.selectedInsuredPerson.insuredPersonId, this.selectedPolicy.policyId, this.selectedProduct.productId);

      if (this.isFuneralProcessingClass()) {
        this.setFuneralFormsBasedOnSelectedCase();
      }
      else if (this.isMedicalProcessingClass()) {
        this.setMedicalFormsBasedOnSelectedCase();
      }
    }
  }

  onEncounterTypeSelectionChanged(name: string): void {
    if (this.encounterTypes) {
      this.selectedEncounterType = this.encounterTypes.find((item) => name === item.name);
    }
  }

  onPayeeSelectionChanged(name: string): void {
    this.clearBeneficiaryName();
    this.beneficiaryHeading = name;
    if (this.allPayees) {
      this.payeeSelected(name);
    }
    this.updateValidatorsByPayeeType(name);
  }

  private payeeSelected(name: string): void {
    if (this.allPayees) {
      this.selectedPayee = this.allPayees.find((item) => name === item.name);
    }
    if (name === 'Nominated Beneficiary') {
      this.isEstate = false;
      this.isNominatedBeneficiary = true;
      this.isAlternativeBeneficiary = false;
      if (this.selectedInsuredPersonWithDates != null) {
        this.getBeneficiary(this.selectedInsuredPersonWithDates.nominatedBeneficiaryNationalIdNumber);
      }
    } else if (name === 'Estate') {
      this.isEstate = true;
      this.isNominatedBeneficiary = false;
      this.isAlternativeBeneficiary = false;
    } else if (name === 'Alternative Beneficiary') {
      this.isEstate = false;
      this.isNominatedBeneficiary = false;
      this.isAlternativeBeneficiary = true;
    } else {
      this.isEstate = false;
      this.isNominatedBeneficiary = false;
      this.isAlternativeBeneficiary = false;
    }
  }

  onReferringProviderOptionChanged(name: string): void {
    if (this.filteredReferringProviders) {
      const provider = this.filteredReferringProviders.find((item) => name === this.getProviderDisplayString(item));
      this.providerSelected(provider.providerId, true);
    }
  }

  onPrescribingProviderOptionChanged(name: string): void {
    if (this.filteredPrescribingProviders) {
      const provider = this.filteredPrescribingProviders.find((item) => name === this.getProviderDisplayString(item));
      this.providerSelected(provider.providerId, false, true);
    }
  }

  onAuthorisationSelectionChanged(authorisationValue: string): void {
    if (authorisationValue != NO_AUTHORISATION) {
      const authorisationNumber = Number(authorisationValue);
      this.claimReviewService.getClaimReview(authorisationNumber).subscribe({
        next: (response) => {
          this.setDiagnosesStepForClaimReview(response);
          this.setActivitiesStepForClaimReview(response, false);
          this.sharedService.openSnackBar('The selected authorisation\'s diagnoses and activities have been applied to the claim', 'Dismiss');
        },
        error: () => this.sharedService.openSnackBar('The selected authorisation\'s diagnoses and activities could NOT be applied to the claim - please apply them manually', 'Dismiss')
      });
    }
  }

  blurDiagnosisDescription(): void {
    if (
      this.filteredDiagnoses &&
      this.filteredDiagnoses.find(
        (item) => this.getDiagnosisDisplayString(item) === this.diagnosisDescriptionFormControl.value
      ) == null
    ) {
      this.diagnosisDescriptionFormControl.reset();
    }
    this.diagnosisFormGroup.markAsTouched();
  }

  onInputChangedSearchDiagnoses($event): void {
    this.diagnosisDescriptionTextChanged.next($event.target.value);
  }

  onDiagnosisOptionChanged(name: string): void {
    if (this.filteredDiagnoses) {
      const diagnosis = this.filteredDiagnoses.find((item) => name === this.getDiagnosisDisplayString(item));
      diagnosis.icdTier = this.diagnosisTierFormControl.value;
      this.selectedDiagnoses.push(diagnosis);
    }
    this.clearDiagnosisDescription();
    this.setDiagnosisTier();
  }

  setDiagnosisTier(): void {
    if (this.isPrimarySelectedOnlyOneAllowed()) {
      this.diagnosisTierFormControl.setValue('Secondary');
    }
    else {
      this.diagnosisTierFormControl.setValue('Primary');
    }
  }

  blurCodingSchemaDescription(formControl: AbstractControl): void {
    if (
      this.getSelectedCodingSchema(formControl.value) == null
    ) {
      formControl.reset();
    }
  }

  onInputChangedSearchCodingSchemas(searchString: string): void {
    this.codingSchemaDescriptionTextChanged.next(searchString);
  }

  getSelectedCodingSchema(name: string): CodingSchemaDTO {
    let codingSchemaDTO: CodingSchemaDTO = null;

    if (this.selectedCodingSchemas && name !== '') {
      codingSchemaDTO = this.selectedCodingSchemas.find((item: CodingSchemaDTO) => name === this.getCodingSchemaDisplayString(item));
    }

    if (codingSchemaDTO == null && this.filteredCodingSchemas && name !== '') {
      codingSchemaDTO = this.filteredCodingSchemas.find((item: CodingSchemaDTO) => name === this.getCodingSchemaDisplayString(item));
    }

    return codingSchemaDTO;
  }

  onAdjudicationStatusSelectionChanged(name: string, activityId: number): void {
    if (this.isReadModeEnabled) {
      return;
    }
    this.openJustificationDialog(activityId, name);
  }

  onTariffCodeTypeSelectionChanged(activity: AbstractControl): void {
    const daysSuppliedCtrl: AbstractControl = activity.get(ActivityControls.DaysSupplied);

    if (!this.hasSpecificCodingCodingSchemaType(activity)) {
      activity.get(ActivityControls.RepeatAuthorised).patchValue(null);
      daysSuppliedCtrl.patchValue(null);
      this.clearValidators(daysSuppliedCtrl);

      const tariffCodeDescriptionCtrl: AbstractControl = activity.get(ActivityControls.CodingSchema);
      this.clearCodingSchemaDescription(tariffCodeDescriptionCtrl);
    }
    else {
      // Case: Claim and Authorisation
      activity.get(ActivityControls.RepeatAuthorised).patchValue(1);

      if (this.isPrimarySubClassPharmacy) {
        daysSuppliedCtrl.patchValue(30);
        activity.get(ActivityControls.Quantity).patchValue(30);
        activity.get(ActivityControls.Quantity).updateValueAndValidity();
      }
      else {
        daysSuppliedCtrl.patchValue(0);
      }

      daysSuppliedCtrl.setValidators(Validators.required);
      daysSuppliedCtrl.updateValueAndValidity();
    }

    if (!this.isTariffCodeTypeEligibleForOverride(activity)) {
      this.clearActivityOverrideIndicators(activity);
    }
  }

  private clearActivityOverrideIndicators(activity: AbstractControl): void {
    activity.get(ActivityControls.LineOverrideIndicator1).patchValue(false);
    activity.get(ActivityControls.LineOverrideIndicator2).patchValue(false);
    activity.get(ActivityControls.LineOverrideIndicator3).patchValue(false);
    activity.get(ActivityControls.LineOverrideIndicator4).patchValue(false);
    activity.get(ActivityControls.ManualCopaymentPercentageOverride).patchValue(null);
  }

  onCodingSchemaOptionChanged(name: string, formControl: AbstractControl): void {
    if (this.filteredCodingSchemas && name !== '') {
      const codingSchema = this.getSelectedCodingSchema(name);
      if (codingSchema == null) {
        this.clearCodingSchemaDescription(formControl);
      }
      else if (
        codingSchema.codingSchemaType.acronym == this.codingSchemaType.ManagerOverrideAuthorizationAcronym
        && !name.includes(this.userFirstLastName)
        && !this.userAuthorisationService.hasRoleAdmin()
      ) {
        this.sharedService.openSnackBar('Only the manager specified in the description can select this manager code', 'Dismiss');
        this.clearCodingSchemaDescription(formControl);
      }
      else {
        this.selectedCodingSchemas.push(codingSchema);
      }
    }
  }

  clearInsuredPersonName(): void {
    this.insuredPersonNameFormControl.reset();
    this.filteredInsuredPersons = [];
    this.selectedInsuredPerson = null;
    this.invalidateOpenAuthorisationLookup();
    this.clearCaseGeneral();
  }

  clearBeneficiaryName(): void {
    this.beneficiaryFormControl.reset();
    this.selectedBeneficiary = null;
    this.filteredBeneficiaries = [];
  }

  clearProviderName(): void {
    this.providerNameFormControl.reset();
    this.selectedProvider = null;
    this.filteredProviders = [];
    this.updatePrescribingProviderValidation();
  }

  clearReferringProviderName(): void {
    this.referringProviderNameFormControl.reset();
    this.selectedReferringProvider = null;
    this.filteredReferringProviders = [];
  }

  isPrescribingProviderRequired(): boolean {
    return this.isMedicalProcessingClass() && this.selectedProvider?.providerSpecialties?.some(
      specialty => /^0*60$/.test(specialty?.providerSpecialtyDTO?.providerCode?.trim() ?? '')
    ) === true;
  }

  private updatePrescribingProviderValidation(): void {
    this.prescribingProviderNameFormControl.setValidators(
      this.isPrescribingProviderRequired() ? [Validators.required] : []
    );
    this.prescribingProviderNameFormControl.updateValueAndValidity();
  }

  clearPrescribingProvider(): void {
    this.prescribingProviderNameFormControl.reset();
    this.selectedPrescribingProvider = null;
    this.filteredPrescribingProviders = [];
  }

  clearDiagnosisDescription(): void {
    this.diagnosisDescriptionFormControl.reset();
    this.filteredDiagnoses = [];
  }

  clearCodingSchemaDescription(formControl: AbstractControl): void {
    formControl.reset();
    this.filteredCodingSchemas = [];
  }

  clearCaseGeneral(): void {
    this.generalCaseFormControl.reset();
    this.selectedGeneralCase = null;
    this.generalCases = [];
    this.selectedPolicy = null;
    this.selectedProduct = null;
    this.clearBeneficiaryName();
    this.selectedInsuredPersonWithDates = null;
  }

  resetClaimFormGroup(): void {
    this.claimFormGroup.reset();
    this.clearInsuredPersonName();
    this.clearCaseGeneral();
    this.claimReceiveDateFormControl.setValue(new Date());
    this.claimFormGroup.setValidators(this.overridesSavedValidator());
  }

  resetEncounterFormGroup(): void {
    this.encounterFormGroup.reset();
    this.payeeSelected('');
    this.clearProviderName();
    this.clearReferringProviderName();
    this.clearPrescribingProvider();
    this.clearBeneficiaryName();
    this.encounterFormGroup.setValidators(this.beneficiarySelectedValidator());
  }

  resetDiagnosisFormGroup(): void {
    this.selectedDiagnoses = [];
    this.diagnosisFormGroup.reset();
    this.clearDiagnosisDescription();
    this.setDiagnosisTier();
    this.diagnosisFormGroup.setValidators([this.primaryDiagnosisSelectedValidator(), this.minimumDiagnosesValidator()]);
  }

  resetActivityFormGroup(): void {
    this.activityFormGroup.reset();
    this.activityFormArray.clear();
    this.selectedCodingSchemas = [];
    this.activityFormGroup.setValidators(this.minimumActivitiesValidator());
    this.activityFormGroup.updateValueAndValidity();
  }

  removeDiagnosis(diagnosis: DiagnosisDTO): void {
    const index = this.selectedDiagnoses.indexOf(diagnosis, 0);
    if (index > -1) {
      this.selectedDiagnoses.splice(index, 1);
    }
    this.setDiagnosisTier();
  }

  addActivityButtonClicked(): void {
    this.addActivityFormGroup();
    this.sharedService.openSnackBar('Activity added', 'Dismiss');
  }

  onAmountClaimedValue(i): void {
    if (this.isActivityAdded()) {
      const index = this.activityFormArray.controls.length - 1 - i;

      const amountClaimedCtrl = this.activityFormArray.controls[index].get(ActivityControls.AmountClaimed);
      const amountClaimedValue = isNaN(Number(amountClaimedCtrl.value)) ? 0 : Number(amountClaimedCtrl.value);
      amountClaimedCtrl.setValue(formatNumber(amountClaimedValue));
      this.onAmountBilledValue(i);
      this.sumActivitiesAmount();
    }
  }

  onAmountBilledValue(i): void {
    if (this.isActivityAdded()) {
      const index = this.activityFormArray.controls.length - 1 - i;
      const amountBilledCtrl = this.activityFormArray.controls[index].get(ActivityControls.AmountBilled);
      const amountBilledValue = isNaN(Number(amountBilledCtrl.value)) ? 0 : Number(amountBilledCtrl.value);
      amountBilledCtrl.setValue(formatNumber(amountBilledValue));
    }
  }

  isActivityAdded(): boolean {
    return this.activityFormArray && this.activityFormArray.controls.length > 0;
  }

  isMedicalClaim(): boolean {
    return this.isMedicalProcessingClass() && this.isClaim;
  }

  showTuneIndicators(): boolean {
    return this.isMedicalProcessingClass() && this.isAuthorisation();
  }

  showActivityTuneIndicators(subActivityGroup: AbstractControl): boolean {
    return this.showTuneIndicators() && this.isTariffCodeTypeEligibleForOverride(subActivityGroup);
  }

  isTariffCodeTypeEligibleForOverride(subActivityGroup: AbstractControl): boolean {
    return this.isActivityWithSpecifiedSchemaType(subActivityGroup, CodingSchemaType.NationalPharmaceuticalProductIndexId)
      || this.isActivityWithSpecifiedSchemaType(subActivityGroup, CodingSchemaType.ReferencePriceListId)
      || this.isActivityWithSpecifiedSchemaType(subActivityGroup, CodingSchemaType.SouthAfricanHospitalRevenueCodesId)
      || this.isActivityWithSpecifiedSchemaType(subActivityGroup, CodingSchemaType.SAPROVId);
  }

  getActiveActivityOverrideCount(subActivityGroup: AbstractControl): number {
    const activeIndicatorCount = [
      ActivityControls.LineOverrideIndicator1,
      ActivityControls.LineOverrideIndicator2,
      ActivityControls.LineOverrideIndicator3,
      ActivityControls.LineOverrideIndicator4,
    ].filter((control: ActivityControls) => !!subActivityGroup.get(control)?.value).length;

    const manualCopaymentPercentageOverride = subActivityGroup.get(ActivityControls.ManualCopaymentPercentageOverride)?.value;
    const isManualCopaymentOverrideActive = manualCopaymentPercentageOverride !== null && manualCopaymentPercentageOverride !== undefined
      && manualCopaymentPercentageOverride > 0;

    return activeIndicatorCount + (isManualCopaymentOverrideActive ? 1 : 0);
  }

  isAuthorisation(): boolean {
    return !this.isClaim;
  }

  isMedicalProcessingClass(): boolean {
    return this.selectedProcessingClass === CaseType.Medical;
  }

  isFuneralProcessingClass(): boolean {
    return this.selectedProcessingClass === CaseType.Funeral;
  }

  isActivityWithSpecifiedSchemaType(activity: AbstractControl, schemaTypeIndex: CodingSchemaType): boolean {
    const codingSchemaTypesToSearch: NameValueDTO[] = this.isFuneral ? this.codingSchemaTypesFuneral : this.codingSchemaTypes;
    const selectedCodingSchemaType = activity.get(ActivityControls.CodingSchemaType).value;
    const matchingCodingSchema: NameValueDTO = codingSchemaTypesToSearch?.find((item: NameValueDTO) => item.name === selectedCodingSchemaType);

    if (!matchingCodingSchema) {
      return false;
    }

    return matchingCodingSchema.value === schemaTypeIndex;
  }

  getActivityInformation(formGroup: AbstractControl, i): ActivityInformationDTO {
    const activity: LineDTO = this.createLine(formGroup, i);
    this.activitiesCount = i + 1;
    const codingSchema = this.getSelectedCodingSchema(formGroup.get(ActivityControls.CodingSchema).value);
    const tariffDescriptionString = codingSchema != null ? `${codingSchema.code} ${codingSchema.shortDescription}` : 'No tariff code selected';
    const startDateString = activity.chargeableTreatmentDate != null ? `${this.datePipe.transform(new Date(activity.chargeableTreatmentDate), this.dateFormat)}` : 'No start date';
    const endDateString = activity.chargeableTreatmentEndDate != null ? `${this.datePipe.transform(new Date(activity.chargeableTreatmentEndDate), this.dateFormat)}` : 'No end date';
    const timeString = this.getTimeString(activity.chargeableStartTime, activity.chargeableEndTime);
    const quantityString = `${activity.chargeableQuantity}`;
    const amountString = `${Number(activity.nettAmount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
    const activityDiagnosis = formGroup.get(ActivityControls.Diagnoses)?.value?.map((diagnosis: DiagnosisDTO) => this.getActivityDiagnosisDisplayString(diagnosis)).join('; ') || 'No diagnosis selected';
    const observations = formGroup.get(ActivityControls.Observations)?.value?.map((observation: ObservationReviewDTO) => this.getObservationDisplayString(observation)).join('; ') || 'No observation data';

    let dateDisplayString = `${startDateString}`;
    if (startDateString !== endDateString) {
      dateDisplayString += ` - ${endDateString} ${timeString}`;
    }
    else {
      dateDisplayString += `${timeString}`;
    }

    let activityInformationDTO: ActivityInformationDTO = new ActivityInformationDTO();
    activityInformationDTO.activityNumber = i + 1;
    activityInformationDTO.activityTariffDescription = tariffDescriptionString;
    activityInformationDTO.date = dateDisplayString;
    activityInformationDTO.quantity = quantityString;
    activityInformationDTO.amount = amountString;
    activityInformationDTO.diagnosis = this.getActivityDiagnosis(activityDiagnosis);
    activityInformationDTO.observations = this.getActivityObservation(formGroup, observations);

    return activityInformationDTO;
  }

  private getActivityObservation(formGroup: AbstractControl, observations: string): string {
    const hasObservations = formGroup.get(ActivityControls.Observations)?.value?.length > 0;
    return hasObservations ? observations : null;
  }

  private getActivityDiagnosis(activityDiagnosis: string): string {
    return this.isPrimarySubClassPharmacy ? activityDiagnosis : null;
  }

  getTimeString(startTime: string, endTime: string): string {
    let returnString = '';
    if (startTime !== endTime) {
      returnString = `from ${startTime} - ${endTime}`;
    }
    return returnString;
  }

  removeActivityFormGroup(formGroup: AbstractControl): void {
    let index = this.activityFormArray.controls.indexOf(formGroup, 0);
    if (index > -1) {
      this.activityFormArray.removeAt(index);
    }

    index = this.selectedCodingSchemas.indexOf(this.getSelectedCodingSchema(formGroup.get(ActivityControls.CodingSchema).value), 0);
    if (index > -1) {
      this.selectedCodingSchemas.splice(index, 1);
    }

    this.activityFormGroup.setValidators(this.minimumActivitiesValidator());
    this.activityFormGroup.updateValueAndValidity();
    this.sumActivitiesAmount();
  }

  openObservationDialog(formGroup: AbstractControl): void {
    const dialogRef = this.dialog.open(AddObservationDialogComponent, {
      width: '95vw',
      height: '80vh',
      data: {observations: formGroup.get(ActivityControls.Observations).value, observationTypes: this.observationTypes}
    });

    dialogRef.afterClosed().subscribe((result: ObservationReviewDTO[]) => {
      if (result) {
        formGroup.get(ActivityControls.Observations).setValue(result);
      }
    });
  }

  createDateRangeString(startDate: Date, endDate: Date): string {
    return `${this.datePipe.transform(startDate, this.dateFormat)} - ${endDate != null ? this.datePipe.transform(endDate, this.dateFormat) : 'current'} `;
  }

  getInsuredPersonDisplayString(insuredPerson: InsuredPersonDTO): string {
    const policyNumber = insuredPerson.policyNumber ? ` - Po: ${insuredPerson.policyNumber}` : '';
    return `${insuredPerson.firstName} ${insuredPerson.lastName} (ID: ${insuredPerson.nationalIdNumber}${policyNumber})`;
  }

  getInsuredPersonNameDisplayString(insuredPerson: InsuredPersonDTO): string {
    const middleName = insuredPerson.middleName != null && insuredPerson.middleName.trim() != '' ? ` ${insuredPerson.middleName.trim()}` : '';
    return `${insuredPerson.firstName}${middleName} ${insuredPerson.lastName}`;
  }

  getCaseDisplayString(caseType: any): string {
    const generalCase: CaseDTO = caseType.caseDTO;
    return `${generalCase.caseId}: ${generalCase.name}`;
  }

  createAssociationDisplayString(selectedInsuredPerson: InsuredPersonDTO): string {
    return selectedInsuredPerson != null && selectedInsuredPerson.association != null ? selectedInsuredPerson.association.name : 'Principal';
  }

  getProviderDisplayString(provider: ProviderDTO): string {
    return getProviderDisplayString(provider);
  }

  getAuthorisationDisplayString(authorisation: ClaimDisplayDTO): string {
    const transactionId: number = authorisation.transactionId;
    const receiveDate: string = this.datePipe.transform(authorisation.receiveDate, this.dateFormat);
    const amount = formatNumber(authorisation.amountClaimed);
    const providerName: string = authorisation.providerName;
    const referenceNumber: string = authorisation.referenceNumber ? `- ${authorisation.referenceNumber}` : '';

    let baseDisplayString = `${transactionId} (${receiveDate} - ${amount} - ${providerName}`;

    if (referenceNumber) {
      baseDisplayString += ` ${referenceNumber}`;
    }
    baseDisplayString += ')';

    return transactionId != null ? baseDisplayString : NO_AUTHORISATION;
  }

  getAuthorisationValue(authorisation: ClaimDisplayDTO): string {
    return authorisation.transactionId != null ? String(authorisation.transactionId) : NO_AUTHORISATION;
  }

  getNominatedBeneficiaryDisplayString(): string {
    let displayString = 'No beneficiary has been nominated.';
    if (this.selectedBeneficiary != null) {
      displayString = `${this.selectedBeneficiary.firstName} ${this.selectedBeneficiary.lastName} - ${this.selectedBeneficiary.nationalIdNumber}`;
    }
    else if (this.beneficiaryIsNominated(this.selectedInsuredPersonWithDates)) {
      displayString = `No record found for ID ${this.selectedInsuredPersonWithDates.nominatedBeneficiaryNationalIdNumber}. Add a person using the button below.`;
    }
    return displayString;
  }

  getDiagnosisDisplayString(diagnosis: DiagnosisDTO): string {
    return `${diagnosis.code}: ${diagnosis.description}`;
  }

  getSortedSelectedDiagnoses(): DiagnosisDTO[] {
    return [...this.selectedDiagnoses].sort((left: DiagnosisDTO, right: DiagnosisDTO) => {
      const tierOrder = this.getDiagnosisTierOrder(left.icdTier) - this.getDiagnosisTierOrder(right.icdTier);
      if (tierOrder !== 0) {
        return tierOrder;
      }

      return (left.code || '').localeCompare(right.code || '', undefined, {numeric: true, sensitivity: 'base'});
    });
  }

  getActivityDiagnosisDisplayString(diagnosis: DiagnosisDTO): string {
    return `${diagnosis.code}: ${diagnosis.description.substring(0, 50)} (${diagnosis.icdTier.substring(0, 1)})`;
  }

  private getDefaultActivityDiagnoses(): DiagnosisDTO[] {
    if (!this.isPrimarySubClassPharmacy || !this.selectedDiagnoses?.length) {
      return [];
    }

    if (this.selectedDiagnoses.length === 1) {
      return [this.selectedDiagnoses[0]];
    }

    return [];
  }

  private applyDefaultDiagnosesToEmptyActivities(): void {
    const defaultDiagnoses = this.getDefaultActivityDiagnoses();
    if (!this.activityFormArray) {
      return;
    }

    this.activityFormArray.controls.forEach((activity: AbstractControl) => {
      const diagnosesControl = activity.get(ActivityControls.Diagnoses);
      if (!diagnosesControl) {
        return;
      }

      const currentDiagnoses: DiagnosisDTO[] = diagnosesControl.value ?? [];
      const syncedCurrentDiagnoses = currentDiagnoses
        .map((diagnosis: DiagnosisDTO) =>
          this.selectedDiagnoses.find((selectedDiagnosis: DiagnosisDTO) => selectedDiagnosis.code === diagnosis.code)
        )
        .filter((diagnosis: DiagnosisDTO | undefined): diagnosis is DiagnosisDTO => diagnosis != null);
      const diagnosesChanged = syncedCurrentDiagnoses.length !== currentDiagnoses.length
        || syncedCurrentDiagnoses.some((diagnosis: DiagnosisDTO, index: number) => diagnosis !== currentDiagnoses[index]);

      if (currentDiagnoses.length === 0 && defaultDiagnoses.length) {
        diagnosesControl.setValue([...defaultDiagnoses]);
      }
      else if (diagnosesChanged) {
        diagnosesControl.setValue(syncedCurrentDiagnoses.length ? syncedCurrentDiagnoses : [...defaultDiagnoses]);
      }
    });
  }

  getObservationDisplayString(observation: ObservationReviewDTO): string {
    return `${observation.observationValue} ${observation.observationType?.name}`;
  }

  getCodingSchemaDisplayString(codingSchema: CodingSchemaDTO): string {
    return codingSchema != null ? `${codingSchema.code}: ${codingSchema.shortDescription}` : '';
  }

  openRuleMessagesDialog(activityId: number): void {
    this.dialog.open(ActivityResultsDialogComponent, {
      minWidth: '40vw',
      height: '40vh',
      data: activityId
    });
  }

  openJustificationHistoryDialog(activityId: number): void {
    const activityReview = this.claimReview.encounter.activities.find(activity => activity.activityId === activityId);
    const displayList: string[] = [];
    displayList.push('Justification;Justifier');
    this.sortAssessmentNarratives(activityReview.assessmentNarratives).forEach(message => {
      displayList.push(`${message.assessmentActionDescription};${message.createdBy}`);
    });
    this.dialog.open(GenericListDialogComponent, {
      width: '80vw',
      height: '80vh',
      data: {list: displayList, heading: 'Justifications'}
    });
  }

  formatRuleDateDisplay(date: Date): string {
    return this.datePipe.transform(new Date(date), 'yyyy/MM/dd HH:mm');
  }

  openJustificationDialog(activityId: number, adjudicationStatus: string, isEdit: boolean = false) {
    // If activityId is 0, update all activities
    let assessmentNarrative: AssessmentNarrativeDTO = null;
    // If editing a narrative
    if (isEdit) {
      // If activityId is 0, use the first activity's narrative
      let activityReview = this.claimReview.encounter.activities[0];
      assessmentNarrative = activityReview.assessmentNarratives.length > 0 ?
        this.sortAssessmentNarratives(activityReview.assessmentNarratives)[0] : null;
      // Otherwise, retrieve the activity's narrative by activity ID
      if (activityId !== 0) {
        activityReview = this.claimReview.encounter.activities.find(activity => activity.activityId === activityId);
        assessmentNarrative = activityReview.assessmentNarratives.length > 0 ? this.sortAssessmentNarratives(activityReview.assessmentNarratives)[0] : null;
      }
      // If logged-in user did not create the narrative, exit and alert the user that the narrative can't be edited
      if (this.userFirstLastName !== assessmentNarrative.createdBy) {
        this.sharedService.openSnackBar('Only the user that created the justification can edit it', 'Dismiss');
        return;
      }
    }
    // Open the dialog with a NULL narrative for a new narrative, or the existing narrative to edit a narrative
    const dialogRef = this.dialog.open(AddJustificationDialogComponent, {
      width: '40vw',
      data: assessmentNarrative
    });

    // Once the dialog is closed, save the results
    dialogRef.afterClosed().subscribe((result: AssessmentNarrativeDTO | null): void => {

      if (!result) {
        this.revertActivityStatus(activityId);
        return;
      }

      let snackbarMessage = '';
      const newAssessmentNarrative: AssessmentNarrativeDTO = result;
      this.isAdjudicationStatusUpdated = true;
      const activities: ActivityReviewDTO[] = this.claimReview.encounter.activities;

      if (activityId === this.AcceptOrRejectAllActivities) {
        const ruleMessageDTOList: RuleMessageDTO[] = [];
        const workflowResultDTOList: WorkflowResultDTO[] = [];

        activities.forEach((a: ActivityReviewDTO) => {

          if (!this.disableActivityStatusUpdateByRole(a.adjudicationStatus.name)) {
            ruleMessageDTOList.push(...this.getSaveRuleMessageDTOList(activities, adjudicationStatus, a.activityId));
            workflowResultDTOList.push(this.getWorkflowResultDTO(adjudicationStatus, a.activityId, this.claimReview.transactionId));
            this.saveNarrative(newAssessmentNarrative, a.activityId);
          }
          else {
            snackbarMessage = 'Not all activity adjudication statuses were overridden as the logged in user does not have sufficient rights';
          }
        });

        if (ruleMessageDTOList?.length) {
          this.saveRuleMessagesList(ruleMessageDTOList);
        }

        if (workflowResultDTOList?.length) {
          this.updateActivityStatusList(workflowResultDTOList);
        }
      }
      else {
        const ruleMessageDTOList: RuleMessageDTO[] = this.getSaveRuleMessageDTOList(activities, adjudicationStatus, activityId);
        this.saveRuleMessagesList(ruleMessageDTOList);
        this.updateActivityStatus(adjudicationStatus, activityId, this.claimReview.transactionId);
        this.saveNarrative(newAssessmentNarrative, activityId, isEdit);
      }
      if (snackbarMessage !== '') {
        this.sharedService.openSnackBar(snackbarMessage, 'Dismiss');
      }
    });
  }

  saveNarrative(assessmentNarrative: AssessmentNarrativeDTO, activityId: number, isEdit: boolean = false) {

    // assessmentNarrativeId will always be null, as can only edit 1 activity's narrative at a time
    // Set the narrative's activityId for each activity

    const assessmentNarrativeToBeSaved: AssessmentNarrativeDTO = {...assessmentNarrative};
    assessmentNarrativeToBeSaved.activityId = activityId;
    this.saveAssessmentNarrative(assessmentNarrativeToBeSaved, activityId, isEdit);
  }

  revertActivityStatus(activityId: number): void {
    // Revert status to what it was
    this.activityFormArray.controls.forEach((formGroup) => {
      if (formGroup.get(ActivityControls.IsReview).value && formGroup.get(ActivityControls.ActivityId).value === activityId) {
        const matchingActivity: ActivityReviewDTO = this.claimReview.encounter.activities.find((activity: ActivityReviewDTO) => activity.activityId === activityId);
        formGroup.get(ActivityControls.AdjudicationStatus).setValue(matchingActivity?.adjudicationStatus.name);
      }
    });
  }

  acceptAllActivities(): void {
    this.processActivities(AdjudicationStatus.Accepted);
  }

  rejectAllActivities(): void {
    this.processActivities(AdjudicationStatus.Rejected);
  }

  processActivities(status: AdjudicationStatus): void {
    if (!this.isAllowedToSubmitTransaction()) {
      this.sharedService.openSnackBar(this.bannerText, 'Dismiss');
      return;
    }
    this.openJustificationDialog(this.AcceptOrRejectAllActivities, status);
  }

  markClaimAsPaid(): void {
    if (!this.isAllowedToSubmitTransaction()) {
      this.sharedService.openSnackBar(this.bannerText, 'Dismiss');
      return;
    }

    const dialogRef = this.dialog.open(AddManualPaymentDialogComponent, {
      width: '40vw',
      data: {
        transactionId: this.claimReview.transactionId,
        paymentId: this.claimReview.paymentId,
        adjudicationStatus: this.disableMarkClaimAsPaidButton() ? AdjudicationStatus.Accepted : AdjudicationStatus.Unknown
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.navigateToRoute('/claim-management', 'claims');
      }
    });
  }

  onClickOpenAddNoteDialog($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

    const dialogRef: MatDialogRef<AddNotesDialogComponent> = this.dialog.open(AddNotesDialogComponent, {
      width: '40vw',
      data: {
        note: this.addNoteFormControl.value,
      }
    });

    dialogRef
      .afterClosed()
      .subscribe((note: string): void => {
        this.addNoteFormControl.patchValue(note);
      });
  }

  onClickOpenAddDocumentDialog($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

    const dialogRef: MatDialogRef<AddDocumentDialogComponent> = this.dialog.open(AddDocumentDialogComponent, {
      width: '60vw',
      data: {
        transactionId: this.isReview ? this.claimReview?.transactionId : null,
        documents: this.isReview ? this.claimReview.documents : []
      }
    });

    dialogRef
      .afterClosed()
      .subscribe((documents: DocumentReviewDTO[]): void => {
        if (documents) {
          this.documents = documents;
          this.claimReview.documents = this.documents;
        }
      });
  }

  refreshBeneficiary(): void {
    if (this.selectedInsuredPersonWithDates) {
      this.getBeneficiary(this.selectedInsuredPersonWithDates.nominatedBeneficiaryNationalIdNumber);
    }
  }

  encounterNextClick(): void {
    if (this.encounterFormGroup.valid) {
      this.claimSubmissionStepper.next();
    }
    else if (this.prescribingProviderNameFormControl.hasError('required')) {
      this.prescribingProviderNameFormControl.markAsTouched();
      this.sharedService.openSnackBar('Prescribing provider is required for pharmacy claims and authorisations', 'Dismiss');
    }
    else if (this.encounterFormGroup.getError('beneficiarySelected')) {
      this.sharedService.openSnackBar('Ensure that a valid beneficiary is selected if the pay to input is set to nominated beneficiary, alternative beneficiary or estate', 'Dismiss');
    }
    else if (this.encounterFormGroup.getError('beneficiaryDifferentToMember')) {
      this.sharedService.openSnackBar('Ensure that the selected beneficiary is not the same as the deceased member if the pay to input is set to nominated beneficiary, alternative beneficiary or estate', 'Dismiss');
    }
  }

  onClaimStepChange(selectedIndex: number): void {
    if (selectedIndex === 3) {
      this.applyDefaultDiagnosesToEmptyActivities();
    }
  }

  diagnosisNextClick(): void {
    if (this.diagnosisFormGroup.valid) {
      this.claimSubmissionStepper.next();
    }
    else {
      // Mark as touched so mat-errors show
      this.diagnosisFormGroup.markAsTouched();
    }
  }

  openAddPersonTab(): void {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/enterprise-management/add-person'])
    );
    window.open(url, '_blank');
  }

  isAdjudicationStatusDisabled(subActivityGroup: AbstractControl): boolean {
    const formGroup = subActivityGroup as FormGroup;
    const status = formGroup.get(ActivityControls.AdjudicationStatus).value;
    return this.isReadModeEnabled || this.disableActivityStatusUpdateByRole(status);
  }

  disableActivityStatusUpdateByRole(status?: string): boolean {
    let disabled = true;
    if (status == null
      && this.isReview
      && this.activityFormArray.controls.find((formGroup) => formGroup.get(ActivityControls.AdjudicationStatus) != null && formGroup.get(ActivityControls.AdjudicationStatus).value === AdjudicationStatus.Rejected)) {
      status = AdjudicationStatus.Rejected;
    }
    if (this.userAuthorisationService.hasRoleTransactionTeamLeader()) {
      disabled = false;
    }
    else if (this.userAuthorisationService.hasRoleClaimsManager() && status !== AdjudicationStatus.Rejected) {
      disabled = false;
    }
    return disabled;
  }

  disableMarkClaimAsPaidButton(): boolean {
    let disabled = false;
    if (!this.isClaim) {
      disabled = true;
    }
    else if (
      (
        this.userAuthorisationService.hasRoleClaimsTeamLeader() ||
        this.userAuthorisationService.hasRoleFinancialTeamLeader()
      ) &&
      !this.isAdjudicationStatusUpdated
    ) {
      if (this.claimReview != null) {
        this.claimReview.encounter?.activities?.forEach((activity: ActivityReviewDTO) => {
          if (activity.adjudicationStatus.name !== AdjudicationStatus.Accepted) {
            disabled = true;
          }
        });
      }
    }
    else {
      disabled = true;
    }
    return disabled;
  }

  activityStatusTooltip(status?: string): string {
    if (status == null
      && this.isReview
      && this.activityFormArray.controls.find((formGroup) => formGroup.get(ActivityControls.AdjudicationStatus) != null && formGroup.get(ActivityControls.AdjudicationStatus).value === AdjudicationStatus.Rejected)) {
      status = AdjudicationStatus.Rejected;
    }
    let tooltip = 'Only claims assessors, claims team leaders and managers have the ability to override activity adjudication statuses.';
    if (this.userAuthorisationService.hasRoleClaimsManager() && status === AdjudicationStatus.Rejected) {
      tooltip = 'Only managers and claims team leaders have the ability to override a rejected activity.';
    }
    else if (this.userAuthorisationService.hasRoleClaimsTeamLeader()) {
      tooltip = 'Managers and claims team leaders have the ability to override rejected claims.';
    }
    return tooltip;
  }

  skipPaymentTooltip(): string {
    let tooltip = 'Only managers and team leaders on the claims and financial teams have the ability to mark a claim as paid. Furthermore, the claim must have been accepted to be marked as paid.';
    if (!this.isClaim) {
      tooltip = 'Only claims can be marked as paid, not authorisations';
    }
    return tooltip;
  }


  onClickShowEncounterOverrideIndicatorsDialog($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();

    const dialogRef: MatDialogRef<EncounterOverrideDialogComponent> = this.dialog.open(EncounterOverrideDialogComponent, {
      width: '40vw',
      data: {
        claimOverrideIndicator1: this.claimOverrideIndicator1FormControl.value,
        isAllowedToEdit: this.userAuthorisationService.hasRolePreAuthorisationTeamLeader()
      }
    });

    dialogRef
      .afterClosed()
      .subscribe((overriddenIndcatorValues: any): void => {
        if (!overriddenIndcatorValues) {
          return;
        }
        const overridedValue1 = overriddenIndcatorValues?.claimOverrideIndicator1 || 0;
        this.claimOverrideIndicator1FormControl.patchValue(overridedValue1);
      });
  }

  onClickShowActivitiesOverrideIndicatorsDialog($event: MouseEvent, subActivityGroup: AbstractControl): void {
    $event.preventDefault();
    $event.stopPropagation();

    const value1 = subActivityGroup.get(ActivityControls.LineOverrideIndicator1).value;
    const value2 = subActivityGroup.get(ActivityControls.LineOverrideIndicator2).value;
    const value3 = subActivityGroup.get(ActivityControls.LineOverrideIndicator3).value;
    const value4 = subActivityGroup.get(ActivityControls.LineOverrideIndicator4).value;
    const manualCopaymentPercentageOverride = subActivityGroup.get(ActivityControls.ManualCopaymentPercentageOverride).value;

    const dialogRef: MatDialogRef<ActivityOverrideDialogComponent> = this.dialog.open(ActivityOverrideDialogComponent, {
      width: '40vw',
      data: {
        [ActivityControls.LineOverrideIndicator1]: value1,
        [ActivityControls.LineOverrideIndicator2]: value2,
        [ActivityControls.LineOverrideIndicator3]: value3,
        [ActivityControls.LineOverrideIndicator4]: value4,
        [ActivityControls.ManualCopaymentPercentageOverride]: manualCopaymentPercentageOverride,
        isAllowedToEdit: this.userAuthorisationService.hasRolePreAuthorisationTeamLeader()
      }
    });

    dialogRef
      .afterClosed()
      .subscribe((overriddenIndcatorValues: any): void => {
        if (!overriddenIndcatorValues) {
          return;
        }
        const overridedValue1 = overriddenIndcatorValues[ActivityControls.LineOverrideIndicator1] || 0;
        const overridedValue2 = overriddenIndcatorValues[ActivityControls.LineOverrideIndicator2] || 0;
        const overridedValue3 = overriddenIndcatorValues[ActivityControls.LineOverrideIndicator3] || 0;
        const overridedValue4 = overriddenIndcatorValues[ActivityControls.LineOverrideIndicator4] || 0;
        const overriddenManualCopaymentPercentageOverride = overriddenIndcatorValues[ActivityControls.ManualCopaymentPercentageOverride] ?? null;

        subActivityGroup.get(ActivityControls.LineOverrideIndicator1).patchValue(overridedValue1);
        subActivityGroup.get(ActivityControls.LineOverrideIndicator2).patchValue(overridedValue2);
        subActivityGroup.get(ActivityControls.LineOverrideIndicator3).patchValue(overridedValue3);
        subActivityGroup.get(ActivityControls.LineOverrideIndicator4).patchValue(overridedValue4);
        subActivityGroup.get(ActivityControls.ManualCopaymentPercentageOverride).patchValue(overriddenManualCopaymentPercentageOverride);
      });
  }

  showSelectedProviderDialog(provider: ProviderDTO): void {
    const COLUMNS_NAMES =
      'Facility Type;City/Town;Title;Contact Person;Contact Number;Start - End Dates;Status;Network';
    const columns: string[] = [COLUMNS_NAMES];

    if (provider) {
      const heading = provider.name;
      columns.push(this.createDisplayStringGenericListDialog(provider));
      this.dialog.open(GenericListDialogComponent, {
        width: '60vw',
        data: {list: columns, heading}
      });
    }
  }

  submitClaim(): void {
    if (this.isClaim && this.isFuneral) {
      this.saveDeceasedDateOverride();
    }
    if (!this.activityFormGroup.valid) {
      this.sharedService.openSnackBar('Ensure all required fields are complete.', 'Dismiss');
      return;
    }
    this.returnMessage = null;
    this.disableActivityPage();

    if (!this.requiresCaseToCaptureTransaction) {
      // Get update fields payload from child and assign
      // to parent fields in order to populate payload.
      this.setPayloadFieldsForMembershipFromUserSelection();
    }

    const request: Request = this.createRequest();
    this.submitClaimRequest(request);
  }

  overridePersonNameClicked($event): void {
    this.editPersonName = $event;

    const personName = new PersonNameDTO();
    personName.firstName = this.selectedInsuredPerson.firstName;
    personName.middleName = this.selectedInsuredPerson.middleName;
    personName.lastName = this.selectedInsuredPerson.lastName;

    const dialogRef = this.dialog.open(EditPersonNameDialogComponent, {
      width: '40vw',
      data: personName
    });

    dialogRef.afterClosed().subscribe((result: PersonNameDTO) => {
      if (result) {
        this.saveFirstNameOverride(result);
        this.saveMiddleNameOverride(result);
        this.saveLastNameOverride(result);
      }
      this.editPersonName = false;
    });

  }

  overrideAssociationClicked($event): void {
    const association = this.selectedInsuredPerson.association ?? CreateNameValueDTO(1, 'Principal');
    this.associationOverrideFormControl.setValue(association.name);
    this.associationOverrideFormControl.markAsTouched();
    this.associationOverrideFormControl.setValidators([Validators.required]);
    this.associationOverrideFormControl.updateValueAndValidity();
    this.editAssociation = $event;
  }

  overrideDateOfBirthClicked($event): void {
    this.dateOfBirthOverrideFormControl.setValue(new Date(this.selectedInsuredPerson.dateOfBirth));
    this.dateOfBirthOverrideFormControl.markAsTouched();
    this.dateOfBirthOverrideFormControl.setValidators([Validators.required]);
    this.dateOfBirthOverrideFormControl.updateValueAndValidity();
    this.editDateOfBirth = $event;
  }

  overrideGenderClicked($event): void {
    this.genderOverrideFormControl.setValue(this.selectedInsuredPerson.gender.name);
    this.genderOverrideFormControl.markAsTouched();
    this.genderOverrideFormControl.setValidators([Validators.required]);
    this.genderOverrideFormControl.updateValueAndValidity();
    this.editGender = $event;
  }

  overrideIdNumberClicked($event) {
    this.idNumberOverrideFormControl.setValue(this.selectedInsuredPerson.nationalIdNumber);
    this.idNumberOverrideFormControl.markAsTouched();
    this.idNumberOverrideFormControl.setValidators([Validators.required]);
    this.idNumberOverrideFormControl.updateValueAndValidity();
    this.editIdNumber = $event;
  }

  showAssociationContentField(): void {
    this.editAssociation = false;
    this.associationOverrideFormControl.clearAsyncValidators();
    this.associationOverrideFormControl.setValidators(null);
    this.associationOverrideFormControl.updateValueAndValidity();
  }

  showDateOfBirthContentField(): void {
    this.editDateOfBirth = false;
    this.dateOfBirthOverrideFormControl.clearAsyncValidators();
    this.dateOfBirthOverrideFormControl.setValidators(null);
    this.dateOfBirthOverrideFormControl.updateValueAndValidity();
  }

  showGenderContentField(): void {
    this.editGender = false;
    this.genderOverrideFormControl.clearAsyncValidators();
    this.genderOverrideFormControl.setValidators(null);
    this.genderOverrideFormControl.updateValueAndValidity();
  }

  showIdNumberContentField(): void {
    this.editIdNumber = false;
    this.idNumberOverrideFormControl.clearAsyncValidators();
    this.idNumberOverrideFormControl.setValidators(null);
    this.idNumberOverrideFormControl.updateValueAndValidity();
  }

  saveFirstNameOverride(personName: PersonNameDTO): void {
    if (this.selectedInsuredPerson.firstName != personName.firstName) {
      this.selectedInsuredPerson.firstName = personName.firstName;

      const dataEntityType = CreateNameValueDTO(1, 'insured_person');
      const dataColumnType = CreateNameValueDTO(1, 'varchar');
      const dataColumnDTO = CreateDataColumnDTO(4, 'firstName', dataColumnType);
      const dataOverride = this.createDataOverrideDTO(personName.firstName, dataEntityType, dataColumnDTO);

      this.saveDataOverride(dataOverride);
    }
  }

  saveMiddleNameOverride(personName: PersonNameDTO): void {
    if ((this.selectedInsuredPerson.middleName ?? '') != (personName.middleName ?? '')) {
      this.selectedInsuredPerson.middleName = personName.middleName ?? '';

      const dataEntityType = CreateNameValueDTO(1, 'insured_person');
      const dataColumnType = CreateNameValueDTO(1, 'varchar');
      const dataColumnDTO = CreateDataColumnDTO(5, 'middleName', dataColumnType);
      const dataOverride = this.createDataOverrideDTO(personName.middleName, dataEntityType, dataColumnDTO);

      this.saveDataOverride(dataOverride);
    }
  }

  saveLastNameOverride(personName: PersonNameDTO): void {
    if (this.selectedInsuredPerson.lastName != personName.lastName) {
      this.selectedInsuredPerson.lastName = personName.lastName;

      const dataEntityType = CreateNameValueDTO(1, 'insured_person');
      const dataColumnType = CreateNameValueDTO(1, 'varchar');
      const dataColumnDTO = CreateDataColumnDTO(6, 'lastName', dataColumnType);
      const dataOverride = this.createDataOverrideDTO(personName.lastName, dataEntityType, dataColumnDTO);

      this.saveDataOverride(dataOverride);
    }
  }

  saveAssociationOverride(): void {
    const association = this.associations.find(item => item.name === this.associationOverrideFormControl.value);
    if (this.selectedInsuredPerson.association?.name != association?.name) {
      this.selectedInsuredPerson.association = association;
      const overrideValue = association?.name;

      const dataEntityType = CreateNameValueDTO(1, 'insured_person');
      const dataColumnType = CreateNameValueDTO(8, 'NameValueDTO');
      const dataColumnDTO = CreateDataColumnDTO(3, 'association', dataColumnType);
      const dataOverride = this.createDataOverrideDTO(overrideValue, dataEntityType, dataColumnDTO);

      this.saveDataOverride(dataOverride);
    }
    this.showAssociationContentField();
  }

  saveDateOfBirthOverride(): void {
    const dateOfBirthNew = new Date(this.dateOfBirthOverrideFormControl.value);
    const dateOfBirthOld = new Date(this.selectedInsuredPerson.dateOfBirth);
    if (dateOfBirthOld.getTime() != dateOfBirthNew.getTime()) {
      this.selectedInsuredPerson.dateOfBirth = dateOfBirthNew;
      const overrideValue = this.datePipe.transform(dateOfBirthNew, this.hyphenatedDateFormat);

      const dataEntityType = CreateNameValueDTO(1, 'insured_person');
      const dataColumnType = CreateNameValueDTO(4, 'date');
      const dataColumnDTO = CreateDataColumnDTO(1, 'birth_date', dataColumnType);
      const dataOverride = this.createDataOverrideDTO(overrideValue, dataEntityType, dataColumnDTO);

      this.saveDataOverride(dataOverride);
    }
    this.showDateOfBirthContentField();
  }

  saveGenderOverride(): void {
    const gender = this.genders.find(item => item.name === this.genderOverrideFormControl.value);
    if (this.selectedInsuredPerson.gender?.name != gender?.name) {
      this.selectedInsuredPerson.gender = gender;
      const overrideValue = gender?.name;

      const dataEntityType = CreateNameValueDTO(1, 'insured_person');
      const dataColumnType = CreateNameValueDTO(8, 'NameValueDTO');
      const dataColumnDTO = CreateDataColumnDTO(2, 'gender', dataColumnType);
      const dataOverride = this.createDataOverrideDTO(overrideValue, dataEntityType, dataColumnDTO);

      this.saveDataOverride(dataOverride);
    }
    this.showGenderContentField();
  }

  saveIdNumberOverride(): void {
    const idNumberNew = this.idNumberOverrideFormControl.value;
    if (this.selectedInsuredPerson.nationalIdNumber != idNumberNew) {
      this.selectedInsuredPerson.nationalIdNumber = idNumberNew;
      const overrideValue = idNumberNew;

      const dataEntityType = CreateNameValueDTO(1, 'insured_person');
      const dataColumnType = CreateNameValueDTO(1, 'varchar');
      const dataColumnDTO = CreateDataColumnDTO(8, 'national_id_number', dataColumnType);
      const dataOverride = this.createDataOverrideDTO(overrideValue, dataEntityType, dataColumnDTO);

      this.saveDataOverride(dataOverride);
    }
    this.showIdNumberContentField();
  }

  saveDeceasedDateOverride(): void {
    const deceasedDateNew = new Date(this.encounterStartDateFormControl.value);
    if (!this.isReview || (this.isReview && new Date(this.claimReview.encounter.startDate).getTime() != deceasedDateNew.getTime())) {
      const overrideValue = this.datePipe.transform(deceasedDateNew, this.hyphenatedDateFormat);
      const dataEntityType = CreateNameValueDTO(1, 'insured_person');
      const dataColumnType = CreateNameValueDTO(4, 'date');
      const dataColumnDTO = CreateDataColumnDTO(7, 'deceased_date', dataColumnType);
      const dataOverride = this.createDataOverrideDTO(overrideValue, dataEntityType, dataColumnDTO);

      this.saveDataOverride(dataOverride);
    }
  }

  allowOverride(): boolean {
    return this.userAuthorisationService.hasRoleClaimsAssessor();
  }

  isClaimFormValid(): boolean {
    // If case is not required, we need to check inner form is valid too
    if (!this.requiresCaseToCaptureTransaction) {
      return this.claimFormGroup.valid && this.isMemberPolicyProductFormValid;
    }
    else {
      return this.claimFormGroup.valid;
    }
  }

  /*
   Depending upon context Label is Dynamically Updated
   - Claim -> 'Amount Claimed'
   - Authorisation -> 'Amount Requested'
   Therefore Using generic name for method
   */

  isAmountRequired(activity: AbstractControl): boolean {
    return this.isClaim || (
      this.isAuthorisation() &&
      !this.isActivityWithSpecifiedSchemaType(
        activity, CodingSchemaType.NationalPharmaceuticalProductIndexId
      )
    );
  }

  onChangeRepeatAuthorizedToggleChange($event: MatSlideToggleChange, subActivityGroup: AbstractControl) {
    if ($event.checked) {
      this.repeatsToggleOnValueAndValidity(subActivityGroup);
    }
    else {
      this.repeatsToggleOffValueAndValidity(subActivityGroup);
    }
  }

  isDaysSuppliedVisible(indexNo: number): boolean {
    const medicalProcessingClass: boolean = this.isMedicalProcessingClass();
    const formGroup: FormGroup = this.getFormGroupAtIndex(indexNo);
    const hasSpecifiedSchemaType: boolean = this.hasSpecificCodingCodingSchemaType(formGroup);
    return medicalProcessingClass && hasSpecifiedSchemaType;
  }

  getFormGroupAtIndex(index: number): FormGroup {
    // Note: This is important to reverse as Activities are displayed in reverse order
    // Inorder to get correct activity it needs to be retrieved with correct index of FormArray

    const reversedIndex = this.activityFormArray.length - 1 - index;
    return this.activityFormArray.at(reversedIndex) as FormGroup;
  }

  getErrorMessages(activityGroup: AbstractControl): string[] {
    const formGroup = activityGroup as FormGroup;
    const startDateControl = formGroup.get(ActivityControls.ActivityStartDate);
    const endDateControl = formGroup.get(ActivityControls.ActivityEndDate);
    const errors = {};

    if (startDateControl?.errors) {
      const startDateErrors = startDateControl.errors;
      if (startDateErrors?.matDatepickerMin) {
        const minDate = this.datePipe.transform(startDateErrors.matDatepickerMin.min, this.hyphenatedDateFormat);
        errors['min'] = `Cannot be less than ${minDate}`;
      }
    }

    if (endDateControl?.errors) {
      const endDateErrors = endDateControl.errors;
      if (endDateErrors?.matDatepickerMax) {
        const maxDate = this.datePipe.transform(endDateErrors.matDatepickerMax.max, this.hyphenatedDateFormat);
        errors['max'] = `Cannot be greater than ${maxDate}`;
      }
    }

    if (Object.keys(errors).length === 0) {
      return [];
    }

    return Object.keys(errors).map(key => {
      switch (key) {
      case 'min':
        return errors[key];
      case 'max':
        return errors[key];
      default:
        return '';
      }
    });
  }

  showEndDateInput() {
    return this.isMedicalProcessingClass();
  }

  encounterEndDateRequired() {
    return this.showEndDateInput() && !this.isPrimarySubClassPharmacy;
  }

  showConsentFields() {
    return this.isAuthorisation() && this.isMedicalProcessingClass();
  }

  onBlurReferenceNumber() {
    if (!this.jiraEnabled) { return; }
    let value: string = this.referenceNumberFormControl?.value;
    if (value == null) { return; }
    value = value.toUpperCase();
    this.containsJiraKey = this.jiraHelperService.containsIssueKey(value);
    if (this.containsJiraKey) {
      this.referenceNumberFormControl.setValue(value);
      this.jiraKey = this.jiraHelperService.extractIssueKey(value);
      this.jiraUrl = this.jiraHelperService.getIssueUrl(this.jiraKey, this.isProviderPortal);
      this.getJiraIssueByKey(this.jiraKey);
    } else {
      this.jiraKey = null;
      this.jiraUrl = null;
    }
  }

  /*
    * PRIVATE METHODS
  */

  private getJiraIssueByKey(key: string) {
    if (!this.jiraEnabled) {
      return;
    }
    this.jiraService.getIssueByKey(key)
      .pipe(
        take(1)
      )
      .subscribe({
        next: (issue) => {
          if (issue) {
            this.jiraIssue = issue;
            this.jiraKeyExists = true;
          } else {
            this.jiraKeyExists = false;
          }
          if (this.containsJiraKey && !this.jiraKeyExists) {
            this.referenceNumberFormControl.setErrors({ jiraNotFound: true });
          } else {
            this.referenceNumberFormControl.setErrors(null);
          }
        },
        error: (err) => {
          console.error('Error:', err);
          this.jiraKeyExists = false;
          this.referenceNumberFormControl.setErrors(null);
        }
      });
  }

  private hasSpecificCodingCodingSchemaType(formGroup: AbstractControl): boolean {
    return this.hasNappiSchemaType(formGroup) || this.hasBenefitBookingCodingSchemaType(formGroup);
  }

  private hasNappiSchemaType(formGroup: AbstractControl): boolean {
    return this.isActivityWithSpecifiedSchemaType(formGroup, CodingSchemaType.NationalPharmaceuticalProductIndexId);
  }

  private hasBenefitBookingCodingSchemaType(formGroup: AbstractControl): boolean {
    /*
      Note: Discussed that Dev instance has ID=9 belongs to Benefit Booking ATM but for different
      client it is different check description in Ticket GD-87. So In dev it will show you Days Supplied
      Field for Benefit Booking as ID=9 but for different client `NAME` can differ, but it will show for
      ID-9 e.g IPBM Id=9 => “Management Directives“
    */
    return this.isActivityWithSpecifiedSchemaType(formGroup, CodingSchemaType.BenefitBookingId);
  }

  private repeatsToggleOffValueAndValidity(subActivityGroup: AbstractControl): void {
    const repeatAuthorisedCtrl: AbstractControl = subActivityGroup.get(ActivityControls.RepeatAuthorised);
    repeatAuthorisedCtrl.setValue(0);
    this.clearValidators(repeatAuthorisedCtrl);
  }

  private repeatsToggleOnValueAndValidity(subActivityGroup: AbstractControl): void {
    subActivityGroup.get(ActivityControls.RepeatAuthorised).setValue(1);
    subActivityGroup.get(ActivityControls.RepeatAuthorised).setValidators([Validators.required, Validators.min(1)]);
    subActivityGroup.get(ActivityControls.RepeatAuthorised).updateValueAndValidity();
  }

  private createDataOverrideDTO(overrideValue: string, dataEntityType: NameValueDTO, dataColumnDTO: DataColumnDTO): DataOverrideDTO {
    const dataOverride = CreateDataOverrideDTO(this.selectedInsuredPerson.insuredPersonId, overrideValue, dataEntityType, dataColumnDTO);
    dataOverride.created = new Date();
    dataOverride.createdBy = this.userFirstLastName;
    return dataOverride;
  }

  private navigateToRoute(path: string, tab: string) {
    this.router.navigate([path], {queryParams: {tab}});
  }

  private openResultsDialog(returnMessage: ReturnMessageDTO): void {
    returnMessage != null ? returnMessage : new ReturnMessageDTO();
    returnMessage.claimType = this.isClaim ? 'Claim' : 'Authorisation';
    returnMessage.isProviderPortal = this.isProviderPortal;
    const dialogRef = this.dialog.open(ClaimResultsDialogComponent, {
      data: returnMessage
    });
    dialogRef.afterClosed().subscribe((transactionId: number) => {
      if (transactionId !== 0 && transactionId != null) {
        const route = this.isClaim ? RoutePaths.ReviewClaim : RoutePaths.ReviewAuthorisation;
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(
          () => this.router.navigate([`/claim-management/${route}/${transactionId}`])
        );
      }
      else {
        this.navigateToRoute('/claim-management', 'claims');
      }
    });
  }

  private beneficiaryIsNominated(person: InsuredPersonWithDatesDTO): boolean {
    return person != null && person.nominatedBeneficiaryNationalIdNumber != null && person.nominatedBeneficiaryNationalIdNumber !== '';
  }

  private requiresSelectedBeneficiary(): boolean {
    if (this.selectedPayee == null) {
      this.payeeSelected(this.payeeFormControl.value);
    }
    return this.selectedPayee.name === 'Nominated Beneficiary' || this.selectedPayee.name === 'Estate' || this.selectedPayee.name === 'Alternative Beneficiary';
  }

  private updateValidatorsByProcessingClass(name: string): void {
    if (name === CaseType.Funeral) {
      this.encounterTypeFormControl.setValue(CaseType.Funeral);
      this.onEncounterTypeSelectionChanged(CaseType.Funeral);
      this.encounterTypeFormControl.disable();
      this.clearEncounterStepEndDateValidators();
      this.clearEncounterStepInvoiceDateValidators();
      this.clearEncounterStepAuthorisationNumberValidators();

    }
    else {
      this.encounterTypeFormControl.enable();

      if (this.encounterEndDateRequired()) {
        this.encounterEndDateFormControl.patchValue(new Date());
        this.encounterEndDateFormControl.setValidators([Validators.required]);
        this.encounterEndDateFormControl.updateValueAndValidity();
      }
      else {
        this.clearEncounterStepEndDateValidators();
      }
      this.providerNameLabel = environment.defaultProviderLabel;
      this.invoiceDateFormControl.setValidators([Validators.required]);
      this.invoiceDateFormControl.updateValueAndValidity();
      if (this.isClaim) {
        this.authorisationNumberFormControl.setValidators([Validators.required]);
        this.authorisationNumberFormControl.updateValueAndValidity();
      }
      else {
        this.clearEncounterStepAuthorisationNumberValidators();
      }
    }
  }

  private clearEncounterStepEndDateValidators(): void {
    this.encounterEndDateFormControl.clearAsyncValidators();
    this.encounterEndDateFormControl.setValidators(null);
    this.encounterEndDateFormControl.updateValueAndValidity();
  }

  private clearEncounterStepInvoiceDateValidators(): void {
    // Invoice Date (For medical claim)
    // Request Date (For medical authorisation)
    this.invoiceDateFormControl.clearAsyncValidators();
    this.invoiceDateFormControl.setValidators(null);
    this.invoiceDateFormControl.updateValueAndValidity();
  }

  private clearEncounterStepAuthorisationNumberValidators(): void {
    this.authorisationNumberFormControl.clearAsyncValidators();
    this.authorisationNumberFormControl.setValidators(null);
    this.authorisationNumberFormControl.updateValueAndValidity();
  }

  private updateValidators(): void {
    this.updateValidatorsByProcessingClass(this.selectedProcessingClass);
    this.updateValidatorsByPayeeType('');

    if (this.isProviderPortal) {
      this.updateFormValidatorsForProviderPortal();
    }
  }

  private updateFormValidatorsForProviderPortal(): void {
    this.processingClassFormControl.disable();
    this.payeeFormControl.disable();
    this.providerNameFormControl.disable();
    this.clearValidators(this.insuredPersonNameFormControl, this.generalCaseFormControl);
  }

  private updateValidatorsByPayeeType(name: string): void {
    if (name === 'Estate' || name === 'Alternative Beneficiary') {
      this.beneficiaryFormControl.setValidators([Validators.required]);
      this.beneficiaryFormControl.updateValueAndValidity();
      this.beneficiaryNarrativeFormControl.setValidators([Validators.required]);
      this.beneficiaryNarrativeFormControl.updateValueAndValidity();
    }
    else {
      this.beneficiaryFormControl.clearAsyncValidators();
      this.beneficiaryFormControl.setValidators(null);
      this.beneficiaryFormControl.updateValueAndValidity();
      this.beneficiaryNarrativeFormControl.clearAsyncValidators();
      this.beneficiaryNarrativeFormControl.setValidators(null);
      this.beneficiaryNarrativeFormControl.updateValueAndValidity();
    }
  }

  private clearValidators(...formControls: FormControl[] | AbstractControl[]): void {
    formControls.forEach(formControl => {
      formControl.clearValidators();
      formControl.updateValueAndValidity();
    });
  }

  private ruleMessageDisplayString(messages: RuleMessageDTO[]): string {
    // Sort descending so that messages are order by rejected, pended then benefit
    messages.sort((n1, n2) => {
      if (n1.created === n2.created) {
        if (n1.actionCode > n2.actionCode && n1.actionCode !== 'SetValue') {
          return -1;
        }
        else if (n1.actionCode < n2.actionCode) {
          return 1;
        }
        else {
          return 0;
        }
      }
      else {
        if (n1.created > n2.created) {
          return -1;
        }
        else if (n1.created < n2.created) {
          return 1;
        }
      }
    });

    // return display string
    const suffix = messages.length > 1 ? ` + ${messages.length - 1} more` : '';
    let message = 'No rule messages';
    if (messages.length > 0) {
      message = (messages[0].description.length > 105 ? `${messages[0].description.slice(0, 105)}...` : messages[0].description) + suffix;
    }
    return message;
  }

  private ruleJustificationDisplayString(justifications: AssessmentNarrativeDTO[]): string {
    // Sort descending so that messages are order by rejected, pended then benefit
    justifications = this.sortAssessmentNarratives(justifications);

    // return display string
    const suffix = justifications.length > 1 ? ` + ${justifications.length - 1} more` : '';
    return justifications.length > 0 ? justifications[0].assessmentActionDescription + suffix : 'No justification set';
  }

  private sortAssessmentNarratives(justifications: AssessmentNarrativeDTO[]): AssessmentNarrativeDTO[] {
    return justifications.sort((n1, n2) => {
      if (n1.assessmentNarrativeId > n2.assessmentNarrativeId || n1.assessmentNarrativeId == null) {
        return -1;
      }
      else if (n1.assessmentNarrativeId < n2.assessmentNarrativeId) {
        return 1;
      }
      else {
        return 0;
      }
    });
  }

  private setFormsForEdit(claimReview: ClaimReviewDTO): void {
    // Claim
    this.setClaimStepForClaimReview(claimReview);

    // Encounter
    this.setEncounterStepForClaimReview(claimReview);

    // Diagnoses
    this.setDiagnosesStepForClaimReview(claimReview);

    // Activities
    this.setActivitiesStepForClaimReview(claimReview);
  }

  private setClaimStepForClaimReview(claimReview: ClaimReviewDTO): void {
    this.memberNameLabel = this.isFuneralProcessingClass() ? 'Deceased Member' : 'Member';
    this.selectedInsuredPerson = claimReview.insuredPerson.insuredPersonDTO;
    this.selectedPolicy = claimReview.caseGeneral.policy;
    this.selectedProduct = claimReview.caseGeneral.product;
    this.selectedInsuredPersonWithDates = claimReview.insuredPerson;
    this.selectedGeneralCase = claimReview.caseGeneral;
    this.addNoteFormControl.setValue(claimReview.note ? claimReview.note : '');
    this.processingClassFormControl.setValue(claimReview.processingClass.name);
    this.processingClassSelected(claimReview.processingClass.name);
    this.claimReceiveDateFormControl.setValue(new Date(claimReview.transactionDate));
    this.insuredPersonNameFormControl.setValue(this.getInsuredPersonDisplayString(this.selectedInsuredPerson));
    this.dateOfBirthOverrideFormControl.setValue(new Date(this.selectedInsuredPerson.dateOfBirth));
    this.generalCaseFormControl.setValue(this.getCaseDisplayString(this.selectedGeneralCase));
    this.getInsuredPersonCases(this.selectedInsuredPerson.insuredPersonId);
    if (this.isClaim && !this.isFuneral) {
      this.getListOfAcceptedAuthorisationsForPerson();
    }
    if (this.showConsentFields()) {
      this.consentIndicatorFormControl.setValue(claimReview.consentIndicator);
      this.consentReasonFormControl.setValue(claimReview.consentReason);
    }
  }

  private setEncounterStepForClaimReview(claimReview: ClaimReviewDTO): void {
    const encounter = claimReview.encounter;
    this.selectedBeneficiary = claimReview.beneficiary;
    this.providerNameLabel = environment.defaultProviderLabel;
    this.providerSelected(encounter.provider.providerId);
    this.encounterTypeFormControl.setValue(encounter.encounterType.name);
    this.onEncounterTypeSelectionChanged(encounter.encounterType.name);
    this.encounterStartDateFormControl.setValue(new Date(encounter.startDate));
    this.invoiceNumberFormControl.setValue(encounter.invoiceNumber && encounter.invoiceNumber != 'null' ? encounter.invoiceNumber : '');
    this.referenceNumberFormControl.setValue(encounter.referenceNumber && encounter.referenceNumber != 'null' ? encounter.referenceNumber : '');
    this.onBlurReferenceNumber();
    this.payeeFormControl.setValue(claimReview.payeeType.name);
    this.payeeSelected(claimReview.payeeType.name);
    if (this.isEstate || this.isAlternativeBeneficiary) {
      this.beneficiaryFormControl.setValue(this.getInsuredPersonDisplayString(this.selectedBeneficiary));
    }
    this.beneficiaryNarrativeFormControl.setValue(claimReview.beneficiaryNarrative);
    this.claimOverrideIndicator1FormControl.setValue(claimReview.encounter?.claimOverrideIndicator1);

    if (claimReview.processingClass.name === CaseType.Medical) {
      if (encounter.endDate) {
        this.encounterEndDateFormControl.setValue(new Date(encounter.endDate));
      }
      this.invoiceDateFormControl.setValue(new Date(encounter.invoiceDate));
      this.authorisationNumberFormControl.setValue(encounter.authorisationNumber);

      if (encounter.referringProvider) {
        this.providerSelected(encounter.referringProvider.providerId, true);
      }

      if (encounter.prescribingProvider) {
        this.providerSelected(encounter.prescribingProvider.providerId, false, true);
      }
    }
  }

  private setDiagnosesStepForClaimReview(claimReview: ClaimReviewDTO): void {
    this.resetDiagnosisFormGroup();
    const diagnoses = claimReview.encounter.diagnoses;
    diagnoses?.forEach(diagnosisReview => {
      const selectedDiagnosis = diagnosisReview.diagnosis;
      selectedDiagnosis.icdTier = diagnosisReview.qualifier === 'P' ? 'Primary' : 'Secondary';
      selectedDiagnosis.diagnosisId = diagnosisReview.diagnosisId;
      this.selectedDiagnoses.push(selectedDiagnosis);
    });
    this.diagnosisFormGroup.updateValueAndValidity();
    this.clearDiagnosisDescription();
    this.setDiagnosisTier();
  }

  private setActivitiesStepForClaimReview(claimReview: ClaimReviewDTO, isReview = true): void {
    this.resetActivityFormGroup();
    const activities: ActivityReviewDTO[] = claimReview.encounter.activities;
    const isMedical: string = claimReview.processingClass.name;

    activities?.forEach((activityReview: ActivityReviewDTO) => {
      const codingSchemaTypeCtrl = new FormControl(activityReview.tariffCode != null ? activityReview.tariffCode.codingSchemaType.name : this.codingSchemaType.SouthAfricanHospitalRevenueCodes, [Validators.required]);
      const codingSchemaCtrl = new FormControl(this.getCodingSchemaDisplayString(activityReview.tariffCode), [Validators.required]);
      const activityStartDateCtrl = new FormControl(new Date(activityReview.activityStartDate), [Validators.required]);
      const activityEndDateCtrl = new FormControl(new Date('9999-12-31'), []);
      const activityTypeCtrl = new FormControl(isMedical ? activityReview.activityType.name : activityReview.activityType.name, [Validators.required]);
      const quantityCtrl = new FormControl(activityReview.quantity, [Validators.required]);
      const amountClaimedCtrl = new FormControl(+formatNumber(activityReview.amountClaimed), [Validators.required]);

      const amountToUse: string = formatNumber(
          (activityReview.amountClaimed && !isNaN(activityReview.amountClaimed))
              ? activityReview.amountBilled
              : activityReview.amountClaimed
      );
      const amountBilledCtrl = new FormControl(amountToUse, this.isMedicalClaim() ? [Validators.required] : []);

      const adjudicationStatusCtrl = new FormControl(activityReview.adjudicationStatus.name, [Validators.required]);
      const justificationsCtrl = new FormControl(this.ruleJustificationDisplayString(activityReview.assessmentNarratives), [Validators.required]);
      const ruleMessagesCtrl = new FormControl(this.ruleMessageDisplayString(activityReview.ruleMessages), [Validators.required]);
      const isCollapsedCtrl = new FormControl(false);
      const isCollapsedRepeatAuthorizedCtrl = new FormControl(!!(isMedical && activityReview.repeatAuthorised));
      const isReviewCtrl = new FormControl(isReview);
      const activityIdCtrl = new FormControl(activityReview.activityId);
      const activityStartTimeCtrl = new FormControl(isMedical ? activityReview.activityStartTime : '12:00', [Validators.required]);
      const activityEndTimeCtrl = new FormControl(isMedical ? activityReview.activityEndTime : '12:00', [Validators.required]);
      const daysSuppliedCtrl = new FormControl(isMedical && activityReview.daysSupplied ? activityReview.daysSupplied : 0);
      const repeatAuthorisedCtrl = new FormControl(isMedical && activityReview.repeatAuthorised ? activityReview.repeatAuthorised : null);
      const observationsCtrl = new FormControl(activityReview.observations);
      const lineOverrideIndicator1Ctrl = new FormControl(activityReview[ActivityControls.LineOverrideIndicator1]);
      const lineOverrideIndicator2Ctrl = new FormControl(activityReview[ActivityControls.LineOverrideIndicator2]);
      const lineOverrideIndicator3Ctrl = new FormControl(activityReview[ActivityControls.LineOverrideIndicator3]);
      const lineOverrideIndicator4Ctrl = new FormControl(activityReview[ActivityControls.LineOverrideIndicator4]);
      const manualCopaymentPercentageOverrideCtrl = new FormControl(activityReview[ActivityControls.ManualCopaymentPercentageOverride]);

      // Create a set for quick lookup
      const reviewDiagnosisCodes = new Set(
        activityReview.diagnoses.map(d => `${d.diagnosisId}`)
      );

      // Filter selectedDiagnoses to include only those that are in the reviewDiagnosisCodes set
      const filteredActivityDiagnoses = this.selectedDiagnoses.filter(x =>
        reviewDiagnosisCodes.has(`${x.diagnosisId}`)
      );

      const diagnosesCtrl = this.isPrimarySubClassPharmacy ?
        new FormControl(
          activityReview && activityReview.diagnoses ? filteredActivityDiagnoses : [],
          [Validators.required, CustomValidator.atLeastOneValue]
        ) : new FormControl();


      if (this.isProviderPortal) {
        this.clearValidators(activityStartTimeCtrl, activityEndTimeCtrl, amountClaimedCtrl);
      }

      const endDate = activityReview.activityEndDate ? new Date(activityReview.activityEndDate) : this.encounterEndDateFormControl?.value;
      if (this.showEndDateInput() && endDate != null) {
        // On Setting Activity Set default date as of Activity from Review Activity
        activityEndDateCtrl.patchValue(endDate);
        activityEndDateCtrl.setValidators(Validators.required);
        activityEndDateCtrl.updateValueAndValidity();
      }

      const group: FormGroup = this.formBuilder.group({
        [ActivityControls.CodingSchemaType]: codingSchemaTypeCtrl,
        [ActivityControls.CodingSchema]: codingSchemaCtrl,
        [ActivityControls.ActivityStartDate]: activityStartDateCtrl,
        [ActivityControls.ActivityEndDate]: activityEndDateCtrl,
        [ActivityControls.ActivityStartTime]: activityStartTimeCtrl,
        [ActivityControls.ActivityEndTime]: activityEndTimeCtrl,
        [ActivityControls.ActivityType]: activityTypeCtrl,
        [ActivityControls.Quantity]: quantityCtrl,
        [ActivityControls.AmountClaimed]: amountClaimedCtrl,
        [ActivityControls.AmountBilled]: amountBilledCtrl,
        [ActivityControls.DaysSupplied]: daysSuppliedCtrl,
        [ActivityControls.AdjudicationStatus]: adjudicationStatusCtrl,
        [ActivityControls.Justifications]: justificationsCtrl,
        [ActivityControls.RuleMessages]: ruleMessagesCtrl,
        [ActivityControls.IsCollapsed]: isCollapsedCtrl,
        [ActivityControls.IsCollapsedRepeatAuthorized]: isCollapsedRepeatAuthorizedCtrl,
        [ActivityControls.IsReview]: isReviewCtrl,
        [ActivityControls.ActivityId]: activityIdCtrl,
        [ActivityControls.RepeatAuthorised]: repeatAuthorisedCtrl,
        [ActivityControls.Diagnoses]: diagnosesCtrl,
        [ActivityControls.Observations]: observationsCtrl,
        [ActivityControls.LineOverrideIndicator1]: lineOverrideIndicator1Ctrl,
        [ActivityControls.LineOverrideIndicator2]: lineOverrideIndicator2Ctrl,
        [ActivityControls.LineOverrideIndicator3]: lineOverrideIndicator3Ctrl,
        [ActivityControls.LineOverrideIndicator4]: lineOverrideIndicator4Ctrl,
        [ActivityControls.ManualCopaymentPercentageOverride]: manualCopaymentPercentageOverrideCtrl,
      });

      this.activityFormArray.push(group);
      this.selectedCodingSchemas.push(activityReview.tariffCode);
    });
    this.sumActivitiesAmount();
  }

  private disableActivityPage(): void {
    this.activityFormGroup.disable();
    this.activityBackButton.disabled = true;
    this.activityClearButton.disabled = true;
    this.finishButton.disabled = true;
    this.addNoteButton.disabled = true;
    this.addDocumentButton.disabled = true;
    this.addActivityButton.disabled = true;
    if (this.isReview) {
      this.acceptAllButton.disabled = true;
      this.rejectAllButton.disabled = true;
      this.skipPaymentButton.disabled = true;
    }
    this.claimStep.editable = false;
    this.encounterStep.editable = false;
    this.diagnosisStep.editable = false;
    this.activityStep.editable = false;
  }

  private enableActivityPage(): void {
    this.activityFormGroup.enable();
    this.activityBackButton.disabled = false;
    this.activityClearButton.disabled = false;
    this.finishButton.disabled = false;
    this.addNoteButton.disabled = false;
    this.addDocumentButton.disabled = false;
    this.addActivityButton.disabled = false;
    if (this.isReview) {
      this.acceptAllButton.disabled = false;
      this.rejectAllButton.disabled = false;
      this.skipPaymentButton.disabled = false;
    }
    this.claimStep.editable = true;
    this.encounterStep.editable = true;
    this.diagnosisStep.editable = true;
    this.activityStep.editable = true;
  }

  private setPayloadFieldsForMembershipFromUserSelection(): void {
    // Assign value of Provider Portal data. Since we are using common component
    const updatePayload = this.memberPolicyProductLink.getPayload();
    this.selectedInsuredPerson = updatePayload.insuredPerson;
    this.selectedProduct = updatePayload.product;
    this.selectedPolicy = updatePayload.policy;
  }

  private createRequest(): Request {
    const request: Request = new Request();
    const claim: ClaimDTO = this.createClaim();
    const membership: MembershipDTO = this.createMembership();
    const claimTotals: ClaimTotalsDTO = this.createClaimTotals();
    const lines: LineDTO[] = this.createLineArray();
    const diagnoses: ClaimDiagnosisDTO[] = this.createDiagnosisArray();
    const documents: DocumentDTO[] = this.createDocumentArray();

    request.Claim = claim;
    request.Membership = membership;
    request.ClaimTotals = claimTotals;
    request.Line = lines;
    request.Diagnosis = diagnoses;
    if (documents != null) {
      request.Document = documents;
    }

    return request;
  }

  private createClaim(): ClaimDTO {
    const claim: ClaimDTO = new ClaimDTO();
    if (this.isReview) {
      claim.transactionId = this.claimReview.transactionId;
    }
    claim.productId = this.selectedProduct.productId;
    claim.providerId = this.selectedProvider.providerId;
    claim.inHospitalClaim = this.checkInHospitalClaim();
    claim.transactionDate = this.datePipe.transform(this.claimReceiveDateFormControl.value, this.hyphenatedDateFormat);
    claim.startDate = this.datePipe.transform(this.encounterStartDateFormControl.value, this.hyphenatedDateFormat);
    if (this.invoiceNumberFormControl.value !== '') {
      claim.invoiceNumber = this.invoiceNumberFormControl.value;
    }
    if (this.referenceNumberFormControl.value !== '') {
      claim.referenceNumber = this.referenceNumberFormControl.value;
    }
    claim.transactionType = this.isClaim ? 'Claim' : 'Authorisation';
    claim.processingClass = this.selectedProcessingClass;

    if (this.isProviderPortal) {
      // We to add CaseId Case Edit for Case Add backend will create caseId
      if (this.isClaim && this.isReview) {
        claim.caseId = this.selectedGeneralCase.caseDTO.caseId;
      }
    }
    else {
      if (this.requiresCaseToCaptureTransaction) {
        claim.caseId = this.selectedGeneralCase.caseDTO.caseId;
      }
    }

    if (this.isFuneralProcessingClass()) {
      claim.invoiceDate = claim.startDate;
      claim.endDate = claim.startDate;
    }
    else if (this.isMedicalProcessingClass()) {
      claim.invoiceDate = this.datePipe.transform(this.invoiceDateFormControl.value, this.hyphenatedDateFormat);
      if (this.encounterEndDateFormControl.value) {
        claim.endDate = this.datePipe.transform(this.encounterEndDateFormControl.value, this.hyphenatedDateFormat);
      }
      if (this.selectedReferringProvider) {
        claim.referringProviderId = this.selectedReferringProvider.providerId;
      }
      if (this.selectedPrescribingProvider) {
        claim.prescribingProviderId = this.selectedPrescribingProvider.providerId;
      }
      if (this.isClaim && !this.isFuneral) {
        claim.authorisationNo = this.authorisationNumberFormControl.value;
      }

      this.handleClaimFieldsBasedOnTuneIndicators(claim);
    }
    claim.sender = this.userFirstLastName;
    claim.note = this.addNoteFormControl.value;

    if (this.consentIndicatorFormControl.value) {
      claim.consentIndicator = 1;
      claim.consentReason = this.consentReasonFormControl.value;
    }

    return claim;
  }

  private handleClaimFieldsBasedOnTuneIndicators(claim: ClaimDTO): void {
    if (this.showTuneIndicators()) {
      claim.claimOverrideIndicator1 = this.claimOverrideIndicator1FormControl?.value ? 1 : 0;
    }
  }

  private checkInHospitalClaim(): string {
    if (this.selectedEncounterType == null) {
      this.onEncounterTypeSelectionChanged(this.encounterTypeFormControl.value);
    }
    return this.selectedEncounterType != null ? this.selectedEncounterType.value.toString() : '0';
  }

  private createMembership(): MembershipDTO {
    const membership = new MembershipDTO();
    membership.personId = this.selectedInsuredPerson.insuredPersonId;
    membership.policyId = this.selectedPolicy.policyId;
    return membership;
  }

  private createClaimTotals(): ClaimTotalsDTO {
    const claimTotals = new ClaimTotalsDTO();
    claimTotals.payInstruction = this.payeeFormControl.value;
    if (this.requiresSelectedBeneficiary()) {
      claimTotals.payToNationalIdNumber = this.selectedBeneficiary.nationalIdNumber;
      claimTotals.payToNarrative = this.beneficiaryNarrativeFormControl.value;
    }
    return claimTotals;
  }

  private createLineArray(): LineDTO[] {
    const lines: LineDTO[] = [];
    let lineNumber = 1;
    this.activityFormArray.controls.forEach((formGroup) => {
      lines.push(this.createLine(formGroup, lineNumber));
      lineNumber++;
    });
    return lines;
  }

  private createLine(formGroup: AbstractControl, lineNumber: number): LineDTO {
    const line: LineDTO = new LineDTO();
    const codingSchema: CodingSchemaDTO = this.getSelectedCodingSchema(formGroup.get(ActivityControls.CodingSchema).value);
    line.lineNo = lineNumber;
    line.itemCodeType = codingSchema != null ? codingSchema.codingSchemaType.acronym : null;
    line.chargeableCode = codingSchema != null ? codingSchema.code : null;
    line.chargeableTreatmentDate = formGroup.get(ActivityControls.ActivityStartDate).value != '' ? this.datePipe.transform(formGroup.get(ActivityControls.ActivityStartDate).value, this.hyphenatedDateFormat) : null;

    const endDate = formGroup.get(ActivityControls.ActivityEndDate)?.value;
    if (this.showEndDateInput() && endDate != null) {
      line.chargeableTreatmentEndDate = endDate != '' ? this.datePipe.transform(endDate, this.hyphenatedDateFormat) : null;
    }

    line.chargeableStartTime = formGroup.get(ActivityControls.ActivityStartTime).value + ':00';
    line.chargeableEndTime = formGroup.get(ActivityControls.ActivityEndTime).value + ':00';
    line.chargeableQuantity = formGroup.get(ActivityControls.Quantity).value;
    line.nettAmount = formGroup.get(ActivityControls.AmountClaimed).value;
    line.grossAmount = formGroup.get(ActivityControls.AmountClaimed).value;
    this.handleLineFieldsBasedOnProcessingClass(formGroup, line);
    this.handleLineFieldsBasedOnTuneIndicators(formGroup, line);
    this.sanitiseBilledClaimedAmount(formGroup, line);
    const observations: ObservationDTO[] = this.CreateObservations(formGroup, lineNumber);
    if (observations != null) {
      line.Observation = observations;
    }
    return line;
  }

  private CreateObservations(formGroup: AbstractControl, lineNumber: number): ObservationDTO[] {
    let observations: ObservationDTO[] = null;
    const observationReviewDTOs: ObservationReviewDTO[] = formGroup.get(ActivityControls.Observations).value;
    if (observationReviewDTOs && observationReviewDTOs.length > 0) {
      observations = [];
      observationReviewDTOs.forEach((observationReviewDTO) => {
        const valueType = observationReviewDTO.valueType.name;
        if (valueType != 'Unknown') {
          const observation = new ObservationDTO();
          observation.lineNo = lineNumber;
          observation.value = observationReviewDTO.observationValue;
          observation.type = this.observationTypes.find(type => type.name === observationReviewDTO.observationType.name)?.code;
          observation.valueType = valueType;
          if (observationReviewDTO.effectiveDate) {
            observation.effectiveDate = this.datePipe.transform(new Date(observationReviewDTO.effectiveDate), this.hyphenatedDateFormat);
          }
          observations.push(observation);
        }
      });
    }
    return observations;
  }

  private handleLineFieldsBasedOnProcessingClass(formGroup: AbstractControl, line: LineDTO): void {
    if (this.isFuneralProcessingClass()) {
      line.lineType = CaseType.Funeral;
      return;
    }
    else if (this.isMedicalProcessingClass()) {
      line.lineType = formGroup.get(ActivityControls.ActivityType).value;

      if (this.hasSpecificCodingCodingSchemaType(formGroup)) {
        // Case: Authorisation
        if (this.isAuthorisation()) {
          const repeatAuthorisedValue = formGroup.get(ActivityControls.RepeatAuthorised)?.value;
          if (repeatAuthorisedValue) {
            line.repeatAuthorised = repeatAuthorisedValue;
          }
        }
        // Applicable to (Medical) Claims + Authorisation
        const daysSuppliedValue = formGroup.get(ActivityControls.DaysSupplied)?.value;
        if (daysSuppliedValue) {
          line.daysSupplied = daysSuppliedValue;
        }
      }

      // Applies to Claim Only
      if (this.isClaim) {
        const billedAmountValue = formGroup.get(ActivityControls.AmountBilled)?.value;
        if (billedAmountValue) {
          line.billedAmount = billedAmountValue;
        }
      }
    }
  }

  private sanitiseBilledClaimedAmount(formGroup: AbstractControl, line: LineDTO): void {
    const isAmountClaimedVisible = !this.isProviderPortal;
    const isAmountBilledVisible = this.isMedicalClaim();
    const amountClaimed = formGroup.get(ActivityControls.AmountClaimed) ? formGroup.get(ActivityControls.AmountClaimed).value : 0;
    const amountBilled = formGroup.get(ActivityControls.AmountBilled) ? formGroup.get(ActivityControls.AmountBilled).value : 0;
    if (isAmountClaimedVisible && !isAmountBilledVisible) {
      line.billedAmount = amountClaimed;
    } else if (isAmountBilledVisible && !isAmountClaimedVisible) {
      line.nettAmount = amountBilled;
    }
  }

  private handleLineFieldsBasedOnTuneIndicators(formGroup: AbstractControl, line: LineDTO): void {
    if (this.showTuneIndicators()) {
      line[ActivityControls.LineOverrideIndicator1] = formGroup.get(ActivityControls.LineOverrideIndicator1)?.value ? 1 : 0;
      line[ActivityControls.LineOverrideIndicator2] = formGroup.get(ActivityControls.LineOverrideIndicator2)?.value ? 1 : 0;
      line[ActivityControls.LineOverrideIndicator3] = formGroup.get(ActivityControls.LineOverrideIndicator3)?.value ? 1 : 0;
      line[ActivityControls.LineOverrideIndicator4] = formGroup.get(ActivityControls.LineOverrideIndicator4)?.value ? 1 : 0;
      line[ActivityControls.ManualCopaymentPercentageOverride] = formGroup.get(ActivityControls.ManualCopaymentPercentageOverride)?.value ?? null;
    }
  }

  private createDiagnosisArray(): ClaimDiagnosisDTO[] {
    const diagnoses: ClaimDiagnosisDTO[] = [];
    if (this.isPrimarySubClassPharmacy) {
      // Add line diagnoses
      let lineNumber = 1;
      this.activityFormArray.controls.forEach((formGroup) => {
        const activityDiagnoses: DiagnosisDTO[] = formGroup.get(ActivityControls.Diagnoses).value;
        activityDiagnoses.forEach((activityDiagnosis) => {
          diagnoses.push(this.createDiagnosis(activityDiagnosis, lineNumber));
        });
        lineNumber++;
      });
      // add other diagnoses that are not in the line diagnoses
      this.selectedDiagnoses.forEach((formGroup) => {
        if (diagnoses.find(d => d.code === formGroup.code) == null) {
          diagnoses.push(this.createDiagnosis(formGroup, null));
        }
      });
    } else {
      this.selectedDiagnoses.forEach((formGroup) => {
        diagnoses.push(this.createDiagnosis(formGroup, null));
      });
    }
    return diagnoses;
  }

  private createDocumentArray(): DocumentDTO[] {
    if (this.documents == null || this.documents.length == 0) {
      return null;
    }
    const documents: DocumentDTO[] = [];
    this.documents.forEach(documentReview => {
      documents.push(this.createDocument(documentReview));
    });
    return documents;
  }

  private createDocument(documentReview: DocumentReviewDTO) {
    const document = new DocumentDTO();
    document.documentType = documentReview.documentType?.code;
    document.fileName = documentReview.fileName;
    document.fileReferenceType = documentReview.documentReferenceType?.code;
    document.fileReferenceValue = document.fileReferenceType == 'FID' && documentReview.fileId != null ? documentReview.fileId.toString() : documentReview.fileUrl;
    return document;
  }

  private createDiagnosis(diagnosisDTO: DiagnosisDTO, lineNumber: number): ClaimDiagnosisDTO {
    const claimDiagnosisDTO = new ClaimDiagnosisDTO();
    if (lineNumber != null) {
      claimDiagnosisDTO.lineNo = lineNumber;
    }
    claimDiagnosisDTO.code = diagnosisDTO.code;
    claimDiagnosisDTO.type = diagnosisDTO.type;
    claimDiagnosisDTO.qualifier = diagnosisDTO.icdTier === 'Primary' ? 'P' : 'S';
    return claimDiagnosisDTO;
  }

  private getDiagnosisTierOrder(icdTier: string): number {
    switch (icdTier) {
      case 'Primary':
        return 0;
      case 'Secondary':
        return 1;
      default:
        return 99;
    }
  }

  private handleUpdatedPolicyData(): void {
    // Open an error dialog
    const dialog = this.dialog.open(ChangedDataErrorDialogComponent, {
      width: '40vw',
      data: 'The policy\'s data has changed since the claim was submitted.\nPlease ensure the case\'s data reflects the latest policy data, then submit a new claim.\n\nWould you like to reject this claim?'
    });
    // Navigate back to claim management when the dialog is closed
    dialog.afterClosed().subscribe((Result) => {
      if (Result) {
        this.claimReview.encounter.activities.forEach(a => {
          this.updateActivityStatus(AdjudicationStatus.Rejected, a.activityId, this.claimReview.transactionId, 'Assessed');
        });
        this.updateTransactionStatus(AdjudicationStatus.Rejected, this.claimReview.transactionId, 'Assessed');
      }
      this.navigateToRoute('/claim-management', 'claims');
    });
  }

  private setVariablesByProcessingClass(processingClass: string): void {
    this.memberNameLabel = processingClass === CaseType.Funeral ? 'Deceased Member' : 'Member';
    this.activityStartDateLabel = processingClass === CaseType.Funeral ? 'Date of Service' : 'Start Date';
    this.encounterStartDateLabel = processingClass === CaseType.Funeral ? 'Deceased Date' : 'Start Date';
    this.isFuneral = processingClass === CaseType.Funeral;
  }

  private setVariablesByUrl(): void {
    const currentRoute: string = this.activatedRoute.snapshot.routeConfig.path;

    if (currentRoute.includes(RoutePaths.SubmitClaim)) {
      this.isClaim = true;
      this.isReview = false;
      this.heading = SUBMIT_A_CLAIM;
      this.invoiceDateLabel = INVOICE_DATE;
      this.amountClaimedLabel = AMOUNT_CLAIMED;
    }
    else if (currentRoute.includes(RoutePaths.SubmitAuthorisation)) {
      this.isClaim = false;
      this.isReview = false;
      this.heading = SUBMIT_AN_AUTHORISATION;
      this.invoiceDateLabel = REQUEST_DATE;
      this.amountClaimedLabel = AMOUNT_REQUESTED;
    }
    else if (currentRoute.includes(RoutePaths.ReviewClaim)) {
      this.isClaim = true;
      this.isReview = true;
      this.heading = REVIEW_A_CLAIM;
      this.invoiceDateLabel = INVOICE_DATE;
      this.amountClaimedLabel = AMOUNT_CLAIMED;
    }
    else if (currentRoute.includes(RoutePaths.ReviewAuthorisation)) {
      this.isClaim = false;
      this.isReview = true;
      this.heading = REVIEW_AN_AUTHORISATION;
      this.invoiceDateLabel = REQUEST_DATE;
      this.amountClaimedLabel = AMOUNT_REQUESTED;
    }
  }

  private setVariablesByPrimarySubClass(subActivityGroup: AbstractControl): void {
    //  Note: Future subtypes can be defined in env file and values can be patched at this place

    if (this.isPrimarySubClassPharmacy) {
      this.encounterTypeFormControl.setValue('Out-patient');
      this.payeeFormControl.setValue('Provider');
      this.payeeSelected('Provider');
      this.onEncounterTypeSelectionChanged('Out-patient');

      const subClassType = this.environmentService.getPrimarySubClass();
      subActivityGroup.get(ActivityControls.ActivityType).patchValue(subClassType);
      subActivityGroup.get(ActivityControls.CodingSchemaType).patchValue(CodingSchemaType.NationalPharmaceuticalProductIndex);

    }
  }

  private createDisplayStringGenericListDialog(provider: ProviderDTO): string {
    let contactsList: ContactArrayDTO[] = [];
    let addressesList: AddressesArrayDTO[] = [];

    if (provider.contacts && provider.contacts.length > 0) {
      contactsList = this.sortByColumn(provider.contacts, 'startDate');
    }
    if (provider.addresses && provider.addresses.length > 0) {
      addressesList = provider.addresses;
    }

    let title, city, contactPerson, contactNumber;
    if (contactsList && contactsList.length > 0) {
      title = `${contactsList[0].contact?.title.name}`;
      contactNumber = `${contactsList[0].contact?.mobileNumber}`;
      contactPerson = `${contactsList[0].contact?.firstName} ${contactsList[0].contact?.lastName}`;
    }
    else {
      title = null;
      contactNumber = null;
      contactPerson = null;
    }

    if (addressesList && addressesList.length > 0) {
      city = provider.addresses[0].address.cityTown;
    }
    else {
      city = null;
    }

    return `${provider.providerFacilityType ? provider.providerFacilityType.name : 'No details available'};
            ${city ? city : 'No details available'};
            ${title ? title : 'No details available'};
            ${contactPerson ? contactPerson : 'No details available'};
            ${contactNumber ? contactNumber : 'No details available'};
            ${this.createDateRangeString(provider.startDate, provider.endDate)};
            ${provider.entityStatus ? provider.entityStatus.name : 'No details available'};
            ${provider.providerNetworkList ? provider.providerNetworkList : 'No details available'}`;
  }

  private sortByColumn(list, columnName: string) {
    return list.sort((firstElement, secondElement) => {
      return (
        new Date(secondElement[columnName]).getTime() -
        new Date(firstElement[columnName]).getTime()
      );
    });
  }

  private setMedicalFormsBasedOnSelectedCase(): void {
    this.setMedicalEncounterFormsBasedOnSelectedCase();
    this.setMedicalDiagnosisFormsBasedOnSelectedCase();
    this.setMedicalActivityFormsBasedOnSelectedCase();
  }

  private setMedicalEncounterFormsBasedOnSelectedCase(): void {
    // Set provider
    const caseProviders: CaseHospitalProviderLinkDTO[] = this.selectedGeneralCase.caseHospitalProviders;
    if (caseProviders != null && caseProviders.length == 1) {
      if (caseProviders[0].provider) {
        this.providerNameFormControl.setValue(this.getProviderDisplayString(caseProviders[0].provider));
        this.providerSelected(caseProviders[0].provider.providerId);
      }
    }
    else if (caseProviders != null && caseProviders.length > 1) {
      let selectedProvider = caseProviders[0].provider;
      caseProviders.forEach(caseProvider => {
        if (caseProvider.providerRole.name === 'Hospital') {
          selectedProvider = caseProvider.provider;
        }
      });
      if (selectedProvider) {
        this.providerNameFormControl.setValue(this.getProviderDisplayString(selectedProvider));
        this.providerSelected(selectedProvider.providerId);
      }
    }
    // Set payee
    this.payeeFormControl.setValue('Provider');
    this.payeeSelected('Provider');
    // Set encounter type
    this.encounterTypeFormControl.setValue('In-patient');
    this.onEncounterTypeSelectionChanged('In-patient');
    // Set encounter start date
    if (this.selectedGeneralCase.caseDTO.startDate) {
      this.encounterStartDateFormControl.setValue(new Date(this.selectedGeneralCase.caseDTO.startDate));
      this.encounterStartDateChanged();
    }
  }

  private setMedicalDiagnosisFormsBasedOnSelectedCase(): void {
    const diagnosisLinks: CaseHospitalDiagnosisLinkDTO[] = this.selectedGeneralCase.caseHospitalDiagnoses || [];
    diagnosisLinks.forEach(diagnosisLink => {
      const diagnosis: DiagnosisDTO = diagnosisLink.diagnosis;
      diagnosis.icdTier = diagnosisLink.icdTier === 'P' ? 'Primary' : 'Secondary';
      this.selectedDiagnoses.push(diagnosis);
    });
    this.diagnosisFormGroup.updateValueAndValidity();
    this.clearDiagnosisDescription();
    this.setDiagnosisTier();
  }

  private setMedicalActivityFormsBasedOnSelectedCase(): void {
    this.resetActivityFormGroup();
    const codingSchemaLinks: CaseHospitalCodingSchemaLinkDTO[] = this.selectedGeneralCase.caseHospitalCodingSchemas;

    if (codingSchemaLinks && codingSchemaLinks.length > 0) {
      codingSchemaLinks.forEach(codingSchemaLink => {
        const codingSchema = codingSchemaLink.codingSchema;
        const group: FormGroup = this.formBuilder.group({
          [ActivityControls.CodingSchemaType]: new FormControl(this.isFuneral ? this.codingSchemaType.FuneralServices : this.codingSchemaType.SouthAfricanHospitalRevenueCodes, [Validators.required]),
          [ActivityControls.CodingSchema]: new FormControl(this.getCodingSchemaDisplayString(codingSchema), [Validators.required]),
          [ActivityControls.ActivityStartDate]: new FormControl(this.encounterStartDateFormControl.value, [Validators.required]),
          [ActivityControls.ActivityStartTime]: new FormControl('12:00', [Validators.required]),
          [ActivityControls.ActivityEndTime]: new FormControl('12:00', [Validators.required]),
          [ActivityControls.ActivityType]: new FormControl('Service', [Validators.required]),
          [ActivityControls.Quantity]: new FormControl(1, [Validators.required]),
          [ActivityControls.DaysSupplied]: new FormControl(null),
          [ActivityControls.AmountClaimed]: new FormControl(formatNumber(0), [Validators.required]),
          [ActivityControls.IsCollapsed]: new FormControl(false),
          [ActivityControls.IsCollapsedRepeatAuthorized]: new FormControl(false),
          [ActivityControls.IsReview]: new FormControl(false),
          [ActivityControls.RepeatAuthorised]:  new FormControl(null),
          [ActivityControls.Observations]:  new FormControl(null)
        });
        this.activityFormArray.push(group);
        this.selectedCodingSchemas.push(codingSchema);
      });
    }
    this.sumActivitiesAmount();
  }

  private setFuneralFormsBasedOnSelectedCase(): void {
    // Set provider
    if (this.selectedGeneralCase.funeralParlour) {
      this.providerNameFormControl.setValue(this.getProviderDisplayString(this.selectedGeneralCase.funeralParlour));
      this.providerSelected(this.selectedGeneralCase.funeralParlour.providerId);
    }
    // Set encounter start date
    if (this.selectedGeneralCase.dateOfDeath) {
      this.encounterStartDateFormControl.setValue(new Date(this.selectedGeneralCase.dateOfDeath));
    }
  }

  private sumActivitiesAmount(): void {
    this.activitiesAmount = 0;

    this.activityFormArray
      .controls
      .forEach((formGroup) => {
        this.activitiesAmount += Number(formGroup.get(ActivityControls.AmountClaimed).value);
    });
  }

  private addActivityFormGroup(): void {
    let defaultCodingSchemaType = this.isFuneral ? this.codingSchemaType.FuneralServices : this.codingSchemaType.SouthAfricanHospitalRevenueCodes;
    if (this.isActivityAdded()) {
      defaultCodingSchemaType = this.activityFormArray.controls[0].get(ActivityControls.CodingSchemaType).value;
    }

    const codingSchemaTypeCtrl = new FormControl(defaultCodingSchemaType, [Validators.required]);
    const codingSchemaCtrl = new FormControl('', [Validators.required]);
    const activityStartDateCtrl = new FormControl(this.encounterStartDateFormControl.value, [Validators.required]);
    const activityEndDateCtrl = new FormControl(new Date('9999-12-31'), []);
    const activityStartTimeCtrl = this.isMedicalProcessingClass() ? new FormControl('12:00', [Validators.required]) : new FormControl('12:00');
    const activityEndTimeCtrl = this.isMedicalProcessingClass() ? new FormControl('12:00', [Validators.required]) : new FormControl('12:00');
    const activityTypeCtrl = new FormControl(this.isMedicalProcessingClass() ? 'Service' : CaseType.Funeral, [Validators.required]);
    const quantityCtrl = new FormControl(1, [Validators.required]);
    const daysSuppliedCtrl = new FormControl(null); // Not required when observation type is None
    const amountClaimedCtrl = new FormControl(+formatNumber(0), [Validators.required]);
    const amountBilledCtrl = new FormControl(+formatNumber(0), this.isMedicalClaim() ? [Validators.required] : []);
    const isCollapsedCtrl = new FormControl(false);
    const isCollapsedRepeatAuthorizedCtrl = new FormControl(false);
    const isReviewCtrl = new FormControl(false);
    const repeatAuthorisedCtrl = new FormControl(null);
    const diagnosesCtrl = this.isPrimarySubClassPharmacy ?
      new FormControl(this.getDefaultActivityDiagnoses(), [Validators.required, CustomValidator.atLeastOneValue]) : new FormControl();
    const observationsCtrl = new FormControl(null);

    const lineOverrideIndicator1Ctrl = new FormControl(false);
    const lineOverrideIndicator2Ctrl = new FormControl(false);
    const lineOverrideIndicator3Ctrl = new FormControl(false);
    const lineOverrideIndicator4Ctrl = new FormControl(false);
    const manualCopaymentPercentageOverrideCtrl = new FormControl(null);

    const group = this.formBuilder.group({
      [ActivityControls.CodingSchemaType]: codingSchemaTypeCtrl,
      [ActivityControls.CodingSchema]: codingSchemaCtrl,
      [ActivityControls.ActivityStartDate]: activityStartDateCtrl,
      [ActivityControls.ActivityEndDate]: activityEndDateCtrl,
      [ActivityControls.ActivityStartTime]: activityStartTimeCtrl,
      [ActivityControls.ActivityEndTime]: activityEndTimeCtrl,
      [ActivityControls.ActivityType]: activityTypeCtrl,
      [ActivityControls.Quantity]: quantityCtrl,
      [ActivityControls.AmountClaimed]: amountClaimedCtrl,
      [ActivityControls.AmountBilled]: amountBilledCtrl,
      [ActivityControls.DaysSupplied]: daysSuppliedCtrl,
      [ActivityControls.IsCollapsed]: isCollapsedCtrl,
      [ActivityControls.IsCollapsedRepeatAuthorized]: isCollapsedRepeatAuthorizedCtrl,
      [ActivityControls.IsReview]: isReviewCtrl,
      [ActivityControls.RepeatAuthorised]: repeatAuthorisedCtrl,
      [ActivityControls.Diagnoses]: diagnosesCtrl,
      [ActivityControls.Observations]: observationsCtrl,
      [ActivityControls.LineOverrideIndicator1]: lineOverrideIndicator1Ctrl,
      [ActivityControls.LineOverrideIndicator2]: lineOverrideIndicator2Ctrl,
      [ActivityControls.LineOverrideIndicator3]: lineOverrideIndicator3Ctrl,
      [ActivityControls.LineOverrideIndicator4]: lineOverrideIndicator4Ctrl,
      [ActivityControls.ManualCopaymentPercentageOverride]: manualCopaymentPercentageOverrideCtrl,
    });

    // Update Controls for Provider Portal
    if (this.isProviderPortal) {
      amountClaimedCtrl.setValue(0);
      this.clearValidators(amountClaimedCtrl);

      codingSchemaTypeCtrl.setValue(this.codingSchemaType.ReferencePriceList);
      codingSchemaTypeCtrl.updateValueAndValidity();
    }

    if (this.isPrimarySubClassPharmacy) {
      daysSuppliedCtrl.setValue(30);
      daysSuppliedCtrl.updateValueAndValidity();
      quantityCtrl.setValue(30);
      quantityCtrl.updateValueAndValidity();
    }

    if (this.showEndDateInput() && this.encounterEndDateFormControl.value != null) {
      // On New Activity Set default date as of Encounter end date
      activityEndDateCtrl.setValue(this.encounterEndDateFormControl.value);
      activityEndDateCtrl.setValidators(Validators.required);
      activityEndDateCtrl.updateValueAndValidity();
    }

    this.setVariablesByPrimarySubClass(group);
    this.activityFormArray.push(group);
    this.filteredCodingSchemas = [];
    if (this.activityFormArray.controls.length > 1) {
      this.activityFormArray.controls[this.activityFormArray.controls.length - 2].get('isCollapsed').setValue(false);
    }
    this.sumActivitiesAmount();
  }

  /*
    * SERVICE CALLS
    */

  private getListOfLookupValues(): Observable<any> {
    const lookupEntities: LookupValue[] = [
      LookupValue.EncounterTypeCode,
      LookupValue.PayeeType,
      LookupValue.ActivityType,
      LookupValue.AdjudicationStatus,
      LookupValue.Association,
      LookupValue.Gender,
      LookupValue.CodingSchemaType,
      LookupValue.ConsentReason
    ];

    const requests: Observable<NameValueDTO[]>[] = lookupEntities.map((entity: string) => this.lookupService.getListOfLookupValues(entity));

    return forkJoin(requests).pipe(
      switchMap((responses: NameValueDTO[][]) => {
        this.handleLookupValuesResponses(responses);
        return of(null); // Wrapping result in an Observable using 'of'
      }),
      catchError((errorResponse: any) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
        return throwError(errorResponse);
      })
    );
  }

  private handleLookupValuesResponses(responses: NameValueDTO[][]): void {
    this.encounterTypes = responses[0];
    this.allPayees = responses[1];
    this.activityTypes = responses[2];
    this.adjudicationStatuses = responses[3];
    this.associations = responses[4];
    this.genders = responses[5];
    this.consentReasons = responses[7];


    if (this.userAuthorisationService.hasRoleTransactionTeamLeader()) {
      this.codingSchemaTypes = responses[6];
    }
    else {
      this.codingSchemaTypes = responses[6].filter(
        (codingSchemaType: NameValueDTO) => (
          codingSchemaType.value !== this.codingSchemaType.ManagerOverrideAuthorizationId &&
          codingSchemaType.value !== this.codingSchemaType.BenefitBookingId
        ));
    }

    this.codingSchemaTypesFuneral = responses[6].filter((codingSchemaType: NameValueDTO) => codingSchemaType.value == this.codingSchemaType.FuneralServicesId || codingSchemaType.value == this.codingSchemaType.ManagerOverrideAuthorizationId);
  }

  private getClaimReview(id: number): Observable<any> {
    return new Observable(observer => {
      this.claimReviewService.getClaimReview(id)
        .pipe(
          take(1),
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe({
          next: (response: ClaimReviewDTO) => observer.next({response}),
          error: (errorResponse) => {
            const error = errorResponse?.error || errorResponse?.message || 'Failed to fetch claim review';
            observer.error({error});
          }
        });
    });
  }

  private getFilteredListOfInsuredPersons(searchText: string): void {
    this.getFilteredListOfInsuredPersonsByField(searchText, 'lastName');
    this.getFilteredListOfInsuredPersonsByField(searchText, 'policyNumber');
  }

  private getFilteredListOfInsuredPersonsByField(searchText: string, filterField: string): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblInsuredPerson;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = PAGE_SIZE;
    pagedRequestDTO.sortField = filterField;
    pagedRequestDTO.sortDirection = 'ASCENDING';

    if (searchText != null && filterField == 'lastName' && (new RegExp('^[0-9]+$').test(searchText) || searchText.includes('_'))) {
      pagedRequestDTO.fieldMap = createFieldMap(
        'nationalIdNumber',
        searchText
      );
    }
    else {
      pagedRequestDTO.fieldMap = createFieldMap(
        filterField,
        searchText
      );
    }

    this.insuredPersonService.getListOfInsuredPersons(pagedRequestDTO)
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe({
        next: (response) => {
          this.filteredInsuredPersons = this.filteredInsuredPersons.concat(response.resultList);
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        },
      });
  }

  private getFilteredListOfBeneficiaries(searchText: string, isEstate = false): void {

    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblInsuredPerson;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = PAGE_SIZE;
    pagedRequestDTO.sortField = 'lastName';
    pagedRequestDTO.sortDirection = 'ASCENDING';

    if (new RegExp('^[0-9]+$').test(searchText) || searchText.includes('_')) {
      pagedRequestDTO.fieldMap = createFieldMap(
        'nationalIdNumber',
        searchText
      );
    }
    else {
      pagedRequestDTO.fieldMap = createFieldMap(
        'lastName',
        searchText
      );
    }

    if (isEstate) {
      const designationPagedFilterDTO = new PagedFilterDTO();
      designationPagedFilterDTO.name = 'designationByDesignationId.name';
      designationPagedFilterDTO.value = 'Estate';
      pagedRequestDTO.fieldMap[`designationByDesignationId`] = designationPagedFilterDTO;
    }

    this.insuredPersonService.getListOfInsuredPersons(pagedRequestDTO)
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe({
        next: (response) => this.filteredBeneficiaries = response.resultList,
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  private getInsuredPersonCases(insuredPersonId: number): void {
    this.generalCases = [];
    if (this.isFuneralProcessingClass()) {
      this.caseService.getInsuredPersonLinkedFuneralCases(insuredPersonId)
        .pipe(
          takeUntil(this.destroyed$)
        )
        .subscribe({
          next: (response) => {
            if (response != null) { this.generalCases = response; }
          },
          error: (errorResponse) => {
            const error = errorResponse.error;
            this.sharedService.openErrorDialog(error.businessMessage);
          }
        });
    } else if (this.isMedicalProcessingClass()) {
      this.caseService.getInsuredPersonLinkedHospitalCases(insuredPersonId)
        .pipe(
          takeUntil(this.destroyed$)
        )
        .subscribe({
          next: (response) => {
            if (response != null) {
              // @ts-ignore
              this.generalCases = response;
            }
          },
          error: (errorResponse) => {
            const error = errorResponse.error;
            this.sharedService.openErrorDialog(error.businessMessage);
          }
        });
    }
  }

  private getInsuredPersonWithDates(insuredPersonId: number, policyId: number, productId: number): void {
    this.insuredPersonService.getInsuredPersonWithDates(insuredPersonId, policyId, productId)
      .subscribe({
        next: (response) => {
          this.selectedInsuredPersonWithDates = response;
          if (this.isNominatedBeneficiary && this.beneficiaryIsNominated(this.selectedInsuredPersonWithDates)) {
            this.getBeneficiary(this.selectedInsuredPersonWithDates.nominatedBeneficiaryNationalIdNumber);
          }
          // If the policy-product-person data is different to the data in the selected case, clear the selection and alert the user
          if (this.selectedInsuredPersonWithDates == null && this.selectedGeneralCase != null) {
            this.clearCaseGeneral();
            this.sharedService.openSnackBar('The policy\'s data has changed since the case was created - please update the policy and product fields on the case accordingly', 'Dismiss');
          }

        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  private buildProviderSearchRequest(searchText: string): PagedRequestDTO {
    const pagedRequestDTO: PagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblProvider;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = FILTER_PAGE_SIZE;
    pagedRequestDTO.sortField = 'name';
    pagedRequestDTO.sortDirection = 'ASCENDING';
    pagedRequestDTO.fieldMap = {};

    // TODO Remove IF once missing provider facility types are completed (PBM-507)
    if (this.isFuneral) {
      const pagedFilterDTO = new PagedFilterDTO();
      pagedFilterDTO.name = 'providerFacilityTypeByProviderFacilityTypeId.providerFacilityTypeId';
      pagedFilterDTO.operator = this.isFuneral ? 'in' : 'not in';
      pagedFilterDTO.value = `${this.providerFacilityType.FUNERAL_PARLOUR},${this.providerFacilityType.REPATRIATION_AGENT}`;
      pagedRequestDTO.fieldMap[`providerFacilityTypeByProviderFacilityTypeId`] = pagedFilterDTO;
    }

    const namePagedFilterDTO = new PagedFilterDTONew();
    namePagedFilterDTO.name = 'name';
    namePagedFilterDTO.value = searchText;
    pagedRequestDTO.fieldMap[`name`] = namePagedFilterDTO;

    const businessLicenseNumberPagedFilterDTO = new PagedFilterDTONew();
    businessLicenseNumberPagedFilterDTO.name = 'businessLicenseNumber';
    businessLicenseNumberPagedFilterDTO.value = searchText;
    businessLicenseNumberPagedFilterDTO.logicGate = 'OR';
    pagedRequestDTO.fieldMap[`businessLicenseNumber`] = businessLicenseNumberPagedFilterDTO;

    const practiceNoPagedFilterDTO = new PagedFilterDTONew();
    practiceNoPagedFilterDTO.name = 'practiceNumber';
    practiceNoPagedFilterDTO.value = searchText;
    practiceNoPagedFilterDTO.logicGate = 'OR';
    pagedRequestDTO.fieldMap['practiceNumber'] = practiceNoPagedFilterDTO;

    return pagedRequestDTO;
  }

  private buildExactPracticeNumberProviderSearchRequest(practiceNumber: string): PagedRequestDTO {
    const pagedRequestDTO = this.buildProviderSearchRequest(practiceNumber);
    delete pagedRequestDTO.fieldMap['name'];
    delete pagedRequestDTO.fieldMap['businessLicenseNumber'];

    const practiceNumberFilter = pagedRequestDTO.fieldMap['practiceNumber'] as PagedFilterDTONew;
    practiceNumberFilter.operator = '==';
    practiceNumberFilter.logicGate = null;
    return pagedRequestDTO;
  }

  private getFilteredListOfProviders(searchText: string, isReferring: boolean = false, isPrescribing: boolean = false): void {
    this.providerService.getListOfProviders(this.buildProviderSearchRequest(searchText))
      .pipe(
        take(1)
      )
      .subscribe({
        next: (response: PagedResponseDTO<ProviderDTO>) => {
          if (isReferring) {
            this.filteredReferringProviders = this.filteredReferringProviders.concat(response.resultList);
          }
          if (isPrescribing) {
            this.filteredPrescribingProviders = this.filteredPrescribingProviders.concat(response.resultList);
          }
          else {
            this.filteredProviders = this.filteredProviders.concat(response.resultList);
          }
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  private providerSelected(providerId: number, isReferring = false, isPrescribing = false) {
    this.providerService.getProvider(providerId)
      .pipe(take(1))
      .subscribe({
        next: (response: ProviderDTO) => {
          if (isReferring) {
            this.selectedReferringProvider = response;
            this.referringProviderNameFormControl.setValue(this.getProviderDisplayString(response));
          }
          else if (isPrescribing) {
            this.selectedPrescribingProvider = response;
            this.prescribingProviderNameFormControl.setValue(this.getProviderDisplayString(response));
          }
          else  {
            this.providerNameFormControl.setValue(this.getProviderDisplayString(response));
            this.selectedProvider = response;
            this.updatePrescribingProviderValidation();
          }
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

// Used by Provider Portal
  private getProviderByPracticeNumber(practiceNo: string): Observable<{
    success: boolean,
    provider?: ProviderDTO,
    error?: any
  }> {
    return new Observable(observer => {
      this.providerService.getProviderByPracticeNumber(practiceNo)
        .pipe(
          take(1),
          finalize(() => {
            observer.complete();
          })
        )
        .subscribe({
          next: (response: ProviderDTO) => observer.next({success: true, provider: response}),
          error: (errorResponse) => observer.next({success: false, error: errorResponse})
        });
    });
  }

  private getBeneficiary(idNumber: string): void {
    this.insuredPersonService.getInsuredPersonByNationalIdNumber(idNumber)
      .pipe(
        takeUntil(this.destroyed$)
      )
      .subscribe({
        next: (response) => {
          this.selectedBeneficiary = response;
          this.encounterFormGroup.updateValueAndValidity();
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  private getListOfAcceptedAuthorisationsForPerson(): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblTransaction;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = 10000;
    pagedRequestDTO.sortField = 'receivedDate';
    pagedRequestDTO.sortDirection = 'DESCENDING';

    pagedRequestDTO.fieldMap = {};

    const classPagedFilterDTO = new PagedFilterDTO();
    classPagedFilterDTO.name = 'processingClassByProcessingClassId.className';
    classPagedFilterDTO.value = this.selectedProcessingClass;
    pagedRequestDTO.fieldMap[`processingClassByProcessingClassId`] = classPagedFilterDTO;

    const typePagedFilterDTO = new PagedFilterDTO();
    typePagedFilterDTO.name = 'transactionTypeId';
    typePagedFilterDTO.value = '1';
    pagedRequestDTO.fieldMap[`transactionTypeId`] = typePagedFilterDTO;

    const stage2PagedFilterDTO = new PagedFilterDTO();
    stage2PagedFilterDTO.name = 'processingStatusId';
    stage2PagedFilterDTO.operator = '<=';
    stage2PagedFilterDTO.value = '12'; // Must be <= 12 so that the authorisation still shows when reviewing claim
    pagedRequestDTO.fieldMap[`processingStatusByProcessingStatusId_2`] = stage2PagedFilterDTO;

    const personPagedFilterDTO = new PagedFilterDTO();
    personPagedFilterDTO.name = 'insuredPersonId';
    personPagedFilterDTO.value = String(this.selectedInsuredPerson.insuredPersonId);
    pagedRequestDTO.fieldMap[`insuredPersonId`] = personPagedFilterDTO;

    this.claimService.getListOfClaims(pagedRequestDTO)
      .pipe(
        take(1),
      )
      .subscribe({
        next: (response: PagedResponseDTO<ClaimDisplayDTO>) => {
          this.authorisations = response.resultList;
          this.authorisations.push(new ClaimDisplayDTO());
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  private getFilteredListOfDiagnoses(searchText: string): void {
    this.getFilteredListOfDiagnosesByField(searchText, 'description');
    this.getFilteredListOfDiagnosesByField(searchText, 'code_2');
  }

  private getFilteredListOfDiagnosesByField(searchText: string, filterField: string): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblDiagnosis;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = FILTER_PAGE_SIZE;

    const fieldMap: {} = createFieldMap(
      filterField,
      searchText
    );

    // TODO: create a method for this
    let pagedFilterDTO = new PagedFilterDTO();
    pagedFilterDTO.name = 'type';
    pagedFilterDTO.value = environment.schema.diagnosisType;
    fieldMap[pagedFilterDTO.name] = pagedFilterDTO;

    if (this.isFuneral) {
      pagedFilterDTO = new PagedFilterDTO();
      pagedFilterDTO.name = 'code_1';
      pagedFilterDTO.operator = 'len';
      pagedFilterDTO.value = '3';
      fieldMap[pagedFilterDTO.name] = pagedFilterDTO;
    }

    if (!this.isFuneral && this.diagnosisTierFormControl.value == 'Primary') {
      pagedFilterDTO = new PagedFilterDTO();
      pagedFilterDTO.name = 'validIcd10Primary';
      pagedFilterDTO.value = 'Y';
      fieldMap[pagedFilterDTO.name] = pagedFilterDTO;
    }

    pagedRequestDTO.fieldMap = fieldMap;
    this.getFilteredListOfDiagnosesByPagedRequestDTO(pagedRequestDTO);
  }

  private getFilteredListOfDiagnosesByPagedRequestDTO(pagedRequestDTO: PagedRequestDTO): void {
    this.diagnosisService.getListOfDiagnoses(pagedRequestDTO)
      .pipe(
        take(1)
      )
      .subscribe({
        next: (response) => {
          this.filteredDiagnoses = this.filteredDiagnoses.concat(response.resultList);
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  private getFilteredListOfCodingSchemasByField(searchString: string): void {
    const searchText: string = searchString.split(';')[0];
    const schemaType: string = searchString.split(';')[1];

    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblCodingSchema;
    pagedRequestDTO.pageNumber = 0;
    pagedRequestDTO.pageSize = FILTER_PAGE_SIZE;
    pagedRequestDTO.fieldMap = {};

    const codingSchemaTypePagedFilterDTO = new PagedFilterDTO();
    codingSchemaTypePagedFilterDTO.name = 'codingSchemaTypeId';
    codingSchemaTypePagedFilterDTO.value = this.codingSchemaTypes.find(x => x.name === schemaType)?.value.toString();
    pagedRequestDTO.fieldMap[`codingSchemaTypeId`] = codingSchemaTypePagedFilterDTO;

    const codePagedFilterDTO = new PagedFilterDTONew();
    codePagedFilterDTO.name = 'code';
    codePagedFilterDTO.value = searchText;
    codePagedFilterDTO.logicGate = 'AND';
    codePagedFilterDTO.bracket = '(';
    pagedRequestDTO.fieldMap[`code`] = codePagedFilterDTO;

    const shortDescriptionPagedFilterDTO = new PagedFilterDTONew();
    shortDescriptionPagedFilterDTO.name = 'shortDescription';
    shortDescriptionPagedFilterDTO.value = searchText;
    shortDescriptionPagedFilterDTO.logicGate = 'OR';
    shortDescriptionPagedFilterDTO.bracket = ')';
    pagedRequestDTO.fieldMap[`shortDescription`] = shortDescriptionPagedFilterDTO;

    if (this.isProviderPortal && this.allowGeneralPractitionerDrugsOnly) {
      /*
        Notes:
       - Add the discipline_1 and discipline_2 fieldmaps as hard-coded fieldmaps
       - Limits the returned results to coding schema values that General Prtactitioners
          would want to see.
      */

      const discipline1PagedFilterDTO = new PagedFilterDTONew();
      discipline1PagedFilterDTO.name = 'discipline';
      discipline1PagedFilterDTO.value = '014';
      discipline1PagedFilterDTO.logicGate = 'AND';
      discipline1PagedFilterDTO.bracket = '(';
      pagedRequestDTO.fieldMap[`discipline_1`] = discipline1PagedFilterDTO;

      const discipline2PagedFilterDTO = new PagedFilterDTONew();
      discipline2PagedFilterDTO.name = 'discipline_2';
      discipline2PagedFilterDTO.value = '015';
      discipline2PagedFilterDTO.logicGate = 'OR';
      discipline2PagedFilterDTO.bracket = ')';
      pagedRequestDTO.fieldMap[`discipline_2`] = discipline2PagedFilterDTO;
    }


    this.codingSchemaService.getListOfCodingSchemas(pagedRequestDTO)
      .pipe(
        take(1)
      )
      .subscribe({
        next: (response) => {
          this.filteredCodingSchemas = this.filteredCodingSchemas.concat(response.resultList);
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  private getSaveRuleMessageDTOList(activities: ActivityReviewDTO[], adjudicationStatus: string, activityId: number): RuleMessageDTO[] {
    return activities
      .find(activity => activity.activityId === activityId).ruleMessages
      .map(message => {
        // Only override rule messages when the adjudication status is changed to Accepted
        message.overrideIndicator = adjudicationStatus === AdjudicationStatus.Accepted ? 1 : 0;
        return message;
      });
  }

  private saveRuleMessagesList(ruleMessageDTOList: RuleMessageDTO[]): void {
    this.ruleMessageService.saveRuleMessageList(ruleMessageDTOList)
      .pipe(
        take(1),
      )
      .subscribe({
        next: (ruleMessages: RuleMessageDTO[]): void => {
          ruleMessages.forEach((message: RuleMessageDTO) => {
            console.log(`Rule ${message.code} updated for activity ID ${message.activityId}`);
          });
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  private saveAssessmentNarrative(assessmentNarrative: AssessmentNarrativeDTO, activityId: number, isEdit: boolean = false): void {
    const assessmentNarrativeWithActivityId: AssessmentNarrativeDTO = new AssessmentNarrativeDTO();
    assessmentNarrativeWithActivityId.activityId = activityId;
    assessmentNarrativeWithActivityId.assessmentNarrativeId = assessmentNarrative.assessmentNarrativeId;
    assessmentNarrativeWithActivityId.assessmentNarrativeType = assessmentNarrative.assessmentNarrativeType;
    assessmentNarrativeWithActivityId.assessmentActionDescription = assessmentNarrative.assessmentActionDescription;
    assessmentNarrativeWithActivityId.created = assessmentNarrative.created;
    assessmentNarrativeWithActivityId.createdBy = assessmentNarrative.createdBy;
    assessmentNarrativeWithActivityId.updated = assessmentNarrative.updated;
    assessmentNarrativeWithActivityId.updatedBy = assessmentNarrative.updatedBy;

    // Get the existing narratives on the activity
    const existingNarratives = this.claimReview.encounter.activities.find(activity => activity.activityId === assessmentNarrativeWithActivityId.activityId).assessmentNarratives;
    // Remove the narrative if it matches the assessmentNarrativeId being edited
    if (isEdit && existingNarratives != null && existingNarratives.length > 0) {
      this.claimReview.encounter.activities.find(activity => activity.activityId === assessmentNarrativeWithActivityId.activityId).assessmentNarratives.splice(existingNarratives.findIndex(deleteNarrative =>
        deleteNarrative.assessmentNarrativeId === assessmentNarrativeWithActivityId.assessmentNarrativeId
      ), 1);
    }

    // Save the narrative
    this.assessmentNarrativeService.saveAssessmentNarrative(assessmentNarrativeWithActivityId)
      .pipe(
        take(1)
      )
      .subscribe({
        next: (assessmentNarrativeSaved) => {
          console.log(`Assessment narrative updated for activity ID ${assessmentNarrativeSaved.activityId}: ${assessmentNarrativeSaved.assessmentActionDescription}`);
          // Add the narrative being saved
          const narrativeCount = this.claimReview.encounter.activities.find(activity => activity.activityId === assessmentNarrativeSaved.activityId).assessmentNarratives.push(assessmentNarrativeSaved);
          // Update the form
          if (this.activityFormArray.controls != null) {
            this.activityFormArray.controls.forEach((formGroup) => {
              if (formGroup.get('isReview').value && formGroup.get('activityId').value === assessmentNarrativeSaved.activityId) {
                formGroup.get('justifications').setValue(`${assessmentNarrativeWithActivityId.assessmentActionDescription}${narrativeCount > 1 ? ' + ' + (narrativeCount - 1) + ' more' : ''}`);
              }
            });
          }
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  private getWorkflowResultDTO(adjudicationStatus: string, activityId: number, transactionId: number, workflowStep: string = 'Unknown'): WorkflowResultDTO {
    const workflowResultDTO: WorkflowResultDTO = new WorkflowResultDTO();
    workflowResultDTO.activityId = activityId;
    workflowResultDTO.transactionId = transactionId;
    workflowResultDTO.result = adjudicationStatus;
    workflowResultDTO.workflowStep = workflowStep;
    workflowResultDTO.isManualIntervention = true;
    return workflowResultDTO;
  }

  private updateActivityStatus(adjudicationStatus: string, activityId: number, transactionId: number, workflowStep: string = 'Unknown'): void {

    // Update Status based on Activity ID
    this.updateActivityAdjudicationStatus(adjudicationStatus, activityId);

    const activityResult = new WorkflowResultDTO();
    activityResult.activityId = activityId;
    activityResult.transactionId = transactionId;
    activityResult.result = adjudicationStatus;
    activityResult.workflowStep = workflowStep;
    activityResult.isManualIntervention = true;

    this.claimService.updateActivityStatus(activityResult)
      .pipe(
        take(1)
      )
      .subscribe({
        next: () => console.log(`Status ${adjudicationStatus} updated for activity ID ${activityId}`),
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        },
      });
  }

  private updateActivityStatusList(workflowResultDTOList: WorkflowResultDTO[]): void {
    // Update Status based on for each workflow item based on activityID
    this.updateActivityAdjudicationStatusList(workflowResultDTOList);

    this.claimService.updateActivityStatusList(workflowResultDTOList)
      .pipe(
        take(1)
      )
      .subscribe({
        next: (workflowResults: WorkflowResultDTO[]): void => {
          workflowResults.forEach((workflowResult: WorkflowResultDTO) => {
            console.log(`Status ${workflowResult.result} updated for activity ID ${workflowResult.activityId}`);
          });
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        },
      });
  }

  private updateActivityAdjudicationStatusList(workflowResultDTOList: WorkflowResultDTO[]): void {
    workflowResultDTOList.forEach((workflowResultDTO: WorkflowResultDTO) => {
      this.updateActivityAdjudicationStatus(workflowResultDTO.result, workflowResultDTO.activityId);
    });
  }

  private updateActivityAdjudicationStatus(adjudicationStatus: string, activityId: number): void {

    const activityFound: ActivityReviewDTO = this.claimReview.encounter.activities.find((activity: ActivityReviewDTO) => activity.activityId === activityId);
    if (activityFound) {
      activityFound.adjudicationStatus = this.adjudicationStatuses.find((status: NameValueDTO) => status.name === adjudicationStatus);
    }

    if (this.activityFormArray.controls) {
      this.activityFormArray.controls
        .filter((formGroup: FormGroup) => formGroup.get('isReview').value && formGroup.get('activityId').value === activityId)
        .forEach((formGroup: FormGroup) => {
          formGroup.get(ActivityControls.AdjudicationStatus).setValue(adjudicationStatus);
        });
    }
  }

  private updateTransactionStatus(adjudicationStatus: string, transactionId, workflowStep: string): void {

    const transactionResult = new WorkflowResultDTO();
    transactionResult.transactionId = transactionId;
    transactionResult.result = adjudicationStatus;
    transactionResult.workflowStep = workflowStep;
    this.claimService.updateTransactionStatus(transactionResult)
      .pipe(
        take(1)
      )
      .subscribe({
        next: () => console.log(`Status ${adjudicationStatus} updated for transaction ID ${transactionId}`),
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  private submitClaimRequest(request: Request): void {
    this.claimService.submitClaim(request, this.isClaim)
      .pipe(
        take(1),
        finalize(() => {
          this.enableActivityPage();
        })
      )
      .subscribe({
        next: (response) => {
          this.returnMessage = response;
          this.openResultsDialog(this.returnMessage);
        },
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.navigateToRoute('/claim-management', 'claims');
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  private saveDataOverride(dataOverride: DataOverrideDTO): void {
    this.dataOverrideService.saveOverride(dataOverride)
      .pipe(
        take(1)
      )
      .subscribe({
        next: () => {},
        error: (errorResponse) => {
          const error = errorResponse.error;
          this.sharedService.openErrorDialog(error.businessMessage);
        }
      });
  }

  protected readonly FormGroup = FormGroup;
}
